import { Component, OnInit, ChangeDetectorRef, OnDestroy, ViewChild, computed, AfterContentChecked } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
	faAngleDown,
	faCompressAlt,
	faDownload,
	faExclamationCircle,
	faExpandAlt,
	faExternalLinkAlt,
	faHourglass,
	faHourglass1,
	faHourglass2,
	faHourglassEnd,
	faQuestionCircle,
	faTrash,
} from '@fortawesome/free-solid-svg-icons';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { changePlanInterface, changePlanDatesInterface } from 'src/app/util/interfaces/changePlan';
import { enduserInterface } from 'src/app/util/interfaces/enduser';
import { logInterface } from 'src/app/util/interfaces/log.interface';
import { relatedArticlesInterface } from 'src/app/util/interfaces/relatedArticles';
import { relatedCisInterface } from 'src/app/util/interfaces/relatedCis';
import { RequestFieldFilterInterface, requestInterface } from 'src/app/util/interfaces/request';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { RequestPageService } from './service/request-page.service';
import { kbArchiveInterface } from 'src/app/util/interfaces/kbArchive';
import { ciTypesInterface } from 'src/app/util/interfaces/ciTypes';
import { ciInterface, ciInterface2 } from 'src/app/util/interfaces/ci';
import { tasksInterface } from 'src/app/util/interfaces/tasks';
import { FilesService } from 'src/app/services/files/files.service';
import {
	iacOptionInterface,
	InputWithAutocompleteComponent,
} from 'src/app/page_component_item/input-with-autocomplete/input-with-autocomplete.component';
import { requestClassificationInterface } from 'src/app/util/interfaces/requestClassification';
import { RequestCustomfieldService } from 'src/app/page_component/request-customfield/service/request-customfield.service';
import { RequestCustomfieldComponent } from 'src/app/page_component/request-customfield/request-customfield.component';
import { genericFormInterface } from 'src/app/util/interfaces/genericForm';
import { PermissionService } from 'src/app/util/services/permission/permission.service';
import { catchError, finalize, forkJoin, of, switchMap, throwError } from 'rxjs';
import { RequestFieldFiltersService } from 'src/app/page/register-page/register-forms/request/request-field-filters/service/request-field-filters.service';
import { CustomerStrikeService } from 'src/app/page/register-page/register-forms/request/customer-strike/service/customer-strike.service';
import * as _ from 'lodash';
import { statusInterface } from 'src/app/util/interfaces/statusInterface';
import { ShkDate } from 'shk-date';
import { mspFileInterface } from 'src/app/util/interfaces/mspFile';
import { mimeTypeInterface } from 'src/app/util/interfaces/mimeTypeInterface';
import { RequestOpeningService } from 'src/app/page_component/request-opening/service/request-opening.service';
import { templateReworkInterface } from 'src/app/util/interfaces/templateRework';
import { GlobalService } from 'src/app/services/global/global.service';
import { emailStatusInterface } from 'src/app/util/interfaces/emailCustom';
import { groupInterface } from 'src/app/util/interfaces/group';
import { CustomerInformationService } from 'src/app/page/register-page/register-forms/customer/customer-information/service/customer-information.service';
import { ClassificationService } from 'src/app/page/register-page/register-forms/classification/classification/service/classification.service';
import { PdfGeneratorService } from 'src/app/util/services/pdf-generator/pdf-generator.service';
import {
	taskManagementInterface,
	TaskManagementService,
} from 'src/app/page/register-page/register-forms/request/task-management/service/task-management.service';
import { CreateRequestResponse } from 'src/app/util/interfaces/createRequestResponse';
import { genericFormI } from 'src/app/util/interfaces/genericFormRMK';
import { RequestUpdatePayload } from 'src/app/util/interfaces/requestUpdatePayload';
import { DateService } from 'src/app/services/date/date.service';
import { TaskCustomField } from 'src/app/util/interfaces/request/taskCustomField';
import { ModalComponent } from 'src/app/page_component_item/modal/modal.component';
import { LocationOption } from 'src/app/util/interfaces/locationInterface';
import { SessionStatus } from 'src/app/services/profile/sessionStatus.enum';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';
import { CommonModule } from '@angular/common';
import { SvgGearsComponent } from 'src/app/page_component_item/svg-gears/svg-gears.component';
import { DotBounceLoadingEffectComponent } from 'src/app/page_component_item/dot-bounce-loading-effect/dot-bounce-loading-effect.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CheckboxComponent } from 'src/app/page_component_item/checkbox/checkbox.component';
import { RequestPageTabAcompanhamentoComponent } from './components/tabs/request-page-tab-acompanhamento/request-page-tab-acompanhamento.component';
import { SearchInformationComponent } from 'src/app/page_component/search-information/search-information.component';
import { FormsModule } from '@angular/forms';
import { RequestClassificationReverseRmkComponent } from 'src/app/page_component/request-classification-reverse-rmk/request-classification-reverse-rmk.component';
import { MspPipesModule } from 'src/app/util/pipes/msp-pipes.module';
import { GenericFormGenModule } from 'src/app/page_component_item/generic-form-gen/generic-form-gen.module';
import { BreadcrumbNavigationComponent } from 'src/app/page_component_item/breadcrumb-navigation/breadcrumb-navigation.component';
import { MspButtonComponent } from 'src/app/page_component_item/msp-button/msp-button.component';
import { InfoAlertComponent } from 'src/app/page_component_item/info-alert/info-alert.component';
import { RequestPageTabSolutionAreaHistoryComponent } from './components/tabs/request-page-tab-solution-area-history/request-page-tab-solution-area-history.component';
import { RequestPageTabRelatedCiComponent } from './components/tabs/request-page-tab-related-ci/request-page-tab-related-ci.component';
import { RequestPageTabRelatedKbComponent } from './components/tabs/request-page-tab-related-kb/request-page-tab-related-kb.component';
import { RequestPageTabChangePlanComponent } from './components/tabs/request-page-tab-change-plan/request-change-plan.component';
import { RequestPageTabAttachmentsComponent } from './components/tabs/request-page-tab-attachments/request-page-tab-attachments.component';
import { RequestPageTabRelatedRequestComponent } from './components/tabs/request-page-tab-related-request/request-page-tab-related-request.component';
import { RequestPageTabExtraOptionsComponent } from './components/tabs/request-page-tab-extra-options/request-page-tab-extra-options.component';
import { RequestPageTabInconsistencyComponent } from './components/tabs/request-page-tab-inconsistency/request-page-tab-inconsistency.component';

@Component({
	standalone: true,
	imports: [
		CommonModule,
		SvgGearsComponent,
		ModalComponent,
		DotBounceLoadingEffectComponent,
		FontAwesomeModule,
		CheckboxComponent,
		SearchInformationComponent,
		RequestCustomfieldComponent,
		FormsModule,
		RequestClassificationReverseRmkComponent,
		InputWithAutocompleteComponent,
		MspPipesModule,
		GenericFormGenModule,
		BreadcrumbNavigationComponent,
		MspButtonComponent,
		InfoAlertComponent,
		RequestPageTabAcompanhamentoComponent,
		RequestPageTabSolutionAreaHistoryComponent,
		RequestPageTabRelatedCiComponent,
		RequestPageTabInconsistencyComponent,
		RequestPageTabChangePlanComponent,
		RequestPageTabRelatedKbComponent,
		RequestPageTabAttachmentsComponent,
		RequestPageTabRelatedRequestComponent,
		RequestPageTabExtraOptionsComponent,
	],
	selector: 'app-request-page',
	templateUrl: './request-page.component.html',
	styleUrls: ['./request-page.component.scss', '../../../../styles/tabs.styles.scss'],
})
export class RequestPageComponent implements OnInit, OnDestroy, AfterContentChecked {
	private readonly logEmailInfoRegex = /<div class="log-email-info">([\S\s]*?)<\/div>/i;

	icons = {
		faExternalLinkAlt: faExternalLinkAlt,
		faTrash: faTrash,
		faAngleDown: faAngleDown,
		faQuestionCircle: faQuestionCircle,
		faExclamationCircle: faExclamationCircle,
		faDownload: faDownload,
		faHourglass: faHourglass,
		faHourglass1: faHourglass1,
		faHourglass2: faHourglass2,
		faHourglassEnd: faHourglassEnd,
		faExpandAlt: faExpandAlt,
		faCompressAlt: faCompressAlt,
	};

	labels: LabelsInterface;

	@ViewChild('logModal') logModal: ModalComponent;
	@ViewChild('cancelRequestModal') cancelRequestModal: ModalComponent;
	@ViewChild('requestCustomfieldComponent') requestCustomfieldComponent?: RequestCustomfieldComponent;

	isAnalystView = this.ProfileService.userData().sessionStatus == SessionStatus.ANALYST;
	isEnduserView = this.ProfileService.userData().sessionStatus == SessionStatus.ENDUSER;

	affectedLocations: LocationOption[] = [];

	isRequestPageLoading = true;
	isLoadingAllStatus = true;
	isLoadingAvailableStatus = true;
	isCustomfieldLoading = true;
	isTaskCustomFieldLoading = true;
	isLoadingAnalysts = true;
	isAvailableCiLoading = true;
	isLoadingEmailCCUsers = true;
	isLoadingTask = true;
	isLoadingAllowedMimeTypes = true;
	isLoadingAvailableTemplates = true;
	isLoadingCiSearch = false;
	isLoadingRequestTemplate = false;
	isLoadingCrisisTeam = false;
	isLoadingCrisisTeamForm = false;
	isLoadingAvailableUsers = false;

	isClassificationLoading = false;
	isSavingLoading = false;
	isSendingLog = false;
	isUpdatingTask = false;
	isUpdatingChangePlan = false;
	isSuperEditingLog = false;
	isRequestBeingEdited = false;
	isRequestBeingReclassified = false;
	isCustomfieldReclassified = false;
	isTabContentContainerFixed = false;
	isSecondaryLogButtonOpen = false;
	isModalOpen = false;
	isClassificationFulfilled = false;
	isOpeningRelatedRequest = false;
	isUserInRemainingApproveList = false;
	reactivationRequestButton = false;
	creatingCustomTask = false;
	isWaitingForApproval = false;
	isDescriptionRequired = false;

	modalView = 'logs';
	customfields: genericFormInterface[] = [];
	customfieldsMemory: genericFormInterface[] = [];
	contractedGroupList: groupInterface[] = [];

	isModalExpanded = false;

	taskCustomFields: TaskCustomField[] = [];
	isLoading = false;
	errorMessage: string | null = null;

	currentKb: relatedArticlesInterface;
	selectedKb: kbArchiveInterface = {
		id: '',
		summary: '',
		description: '',
		status: 'new',
		visibility: '',
		language: '',
	};

	requestData: requestInterface = {
		status: '',
		id: '',
		id_service_type: '',
		service_type: '',
		scope: '',
		category: '',
		topic: '',
		solution_area: '',
		severity: '',
		high_severity: false,
		id_severity: '',
		id_solution_area: '',
		id_analyst: '-1',
		analyst: '',
		email_analyst: '',
		count_strikes: '',
		classification_date: '',
		confidential: '',
		relatedArticles: [],
		changePlanDates: [],
	};

	initialRequestData: any = {};

	newRequestData: any = {};
	newCustomfields: any = {};

	requestDataMemory: requestInterface = {
		status: '',
		id: '',
		id_service_type: '',
		service_type: '',
		scope: '',
		category: '',
		topic: '',
		solution_area: '',
		severity: '',
		riskType: '',
		high_severity: false,
		id_solution_area: '',
		id_analyst: '-1',
		analyst: '',
		email_analyst: '',
		count_strikes: '',
		confidential: '',
		classification_date: '',
	};
	availableAnalysts: enduserInterface[] = [];

	allStatus: statusInterface[] = [];
	allStatusAsLabel = {};
	availableEmailStatus: emailStatusInterface[] = [];
	availableStatus: statusInterface[] = [{ status: 'New', label: 'New' }];

	availableCiTypes: ciTypesInterface[] = [];
	bondedCisArr: string[] = [];

	taskOptions: taskManagementInterface[] = [];
	taskIdList: (string | number)[] = [];

	selectedFilterEnduser: string[] = [];
	selectedFilterAnalyst: string[] = [];
	searchCiParameter: ciInterface = {
		ciType: '',
		ciIcon: '',
		ciArray: [
			{
				id: '',
				cmdb_id: '',
				type: '',
				status: '',
				identification: '',
			},
		],
	};

	customConfidentialForm = new genericFormI('multi-select');
	customConfidentialFormMemory: genericFormI<'multi-select'>;

	relatedRequestOptions = {
		hide: ['classifyButton', 'enduser'],
		hide_service_type: ['2', '5'],
		initial_enduser: null,
		initial_id_enduser: null,
		initial_summary: '',
		initial_related_request_id: '',
	};
	classificationOptions = {
		isEditingClassification: true,
		initOn: 'changeType',
		hideField: [],
		alertField: [],
		lockField: ['severity'],
		selectedCustomer: null,
	};
	reverseClassification = true;
	classificationIds: {
		idSolutionArea: string;
		idServiceType: string;
		idScope: string;
		idCategory: string;
		idTopic: string;
		idImpact: string;
		idUrgency: string;
		idSeverity: string;
	} = {
		idSolutionArea: undefined,
		idServiceType: undefined,
		idScope: undefined,
		idCategory: undefined,
		idTopic: undefined,
		idImpact: undefined,
		idUrgency: undefined,
		idSeverity: undefined,
	};
	availableServiceTypes: string[] = [];

	newLog: logInterface = {
		analyst: '',
		duration: '',
		idLog: '',
		log_date: '',
		notes: '',
		status: '',
		overdueReason: '',
		email_cc: '',
		file_log: [],
		sendEmailAttachEnduser: false,
	};
	newSuperLog: logInterface = {
		analyst: '',
		duration: '',
		idLog: '',
		log_date: '',
		notes: '',
		status: '',
		overdueReason: '',
		file_log: [],
	};
	allowedMimeTypes: mimeTypeInterface[] = [];
	allowedMimeTypeStr = '';
	allowedMimeTypeTip = '';

	availableEmailCCUsersIAC: iacOptionInterface[] = [];
	selectedEmailCCUserIAC: iacOptionInterface = { name: '', value: '' };

	requestTemplateId: string;
	availableTemplateIAC: iacOptionInterface[] = [];
	requestTemplate: templateReworkInterface;

	reclassifyReason = '';

	newTask: tasksInterface = {
		predecessor: 0,
		task_description: '',
		task_status: '',
		task_order_number: '',
		id_task: '',
		show_buttons: false,
		task_available_status: [],
		task_type: '',
		task_analyst: undefined,
		task_id_solution_area: '',
		available_task_approver: [],
		selected_task_approver: [],
		available_task_analysts: [],
		already_approved_analysts: [],
		attachment: [],
		upload_required: '',
	};

	changePlanDates: changePlanDatesInterface = {
		startDateAgreed: '', // Data de início acordada
		startTimeAgreed: '', // Hora de início acordada
		endDateAgreed: '', // Data limite acordada
		endTimeAgreed: '', // Hora limite acordada
		execStartDate: '', // Data de execução
		execStartTime: '', // Hora de execução
		execEndDate: '', // Data de fim da execução
		execEndTime: '', // Hora de fim da execução
		unavailabilityStartDate: '', // Data de indisponibilidade inicial
		unavailabilityStartTime: '', // Hora de indisponibilidade inicial
		unavailabilityEndDate: '', // Data de indisponibilidade final
		unavailabilityEndTime: '', // Hora de indisponibilidade final
	};

	validationErrors: { [key: string]: boolean } = {};
	isDatesChangePlanMissing = true;
	missingFields: string[] = [];

	actualTab = 'Acompanhamento';
	tabs = [];

	ghostResizeBar = {
		mouseDown: false,
		startX: null,
		contentContainer: 40,
		tabContentWidth: 60,
	};

	newCustomTask: taskManagementInterface[] = [];
	solutionAreas: string[] = [];
	customTaskPredecessor = [];

	countDownSlaInterval = null;

	userView = this.ProfileService.userData().sessionStatus;
	userViewTypes = SessionStatus;

	_isCustomfieldFulfilled = true;

	threeStrikes: number = null;
	selectedOption: string = null;
	duplicateRequestInfo = false;
	applyStrike = false;
	closeChildRequests = false;

	sendEmailEnduser = false;
	sendEmailAttachEnduser = false;

	duplicateTimeout: any;
	minutes = 0;
	hours = 0;
	startTimer = false;
	cron: any;
	cronIcon: any;
	showTime: string = this.newLog.duration;
	currentTimerIcon: any = this.icons.faHourglass;
	newSubRequestCreated = false;
	confidentialCanEdit = true;
	canSetDriver = false;
	changeAnalystToDriver = false;

	closedStatuses = [
		'Closed - On-Line Evaluation',
		'Closed - On-Line Mobile Evaluation',
		'Closed - Telephone Evaluation',
		'Closed - Timeout',
		'Solved',
	];

	hasMatchingActiveGroup: any = '';
	searchResult: any = '';

	crisisTeamForm: genericFormInterface[] = [];

	constructor(
		private ActivatedRoute: ActivatedRoute,
		private RequestPageService: RequestPageService,
		private RequestCustomfieldService: RequestCustomfieldService,
		private LabelsService: LabelsService,
		private Router: Router,
		private FilesService: FilesService,
		private cdref: ChangeDetectorRef,
		private RequestFieldFiltersService: RequestFieldFiltersService,
		private CustomerStrikeService: CustomerStrikeService,
		private RequestOpeningService: RequestOpeningService,
		private CustomerInformationService: CustomerInformationService,
		private PdfGeneratorService: PdfGeneratorService,
		public NotificationService: NotificationService,
		public permissionService: PermissionService,
		public ProfileService: ProfileService,
		public ClassificationService: ClassificationService,
		public taskManagementService: TaskManagementService,
		public dateService: DateService
	) {
		this.labels = computed(() => {
			return this.LabelsService.labels();
		})();
	}

	ngOnInit(): void {
		this.RequestPageService.getAvailableEmailCCUsers().subscribe((users) => {
			for (const user of users) {
				const userIAC: iacOptionInterface = {
					name: user.email,
					value: user.email,
				};
				this.availableEmailCCUsersIAC.push(userIAC);
			}
			this.isLoadingEmailCCUsers = false;
		});

		this.customConfidentialForm.name = 'confidentialUsers';
		this.customConfidentialForm.label = 'lbl_quem_podera_visualizar';

		this.RequestPageService.getCitypes().subscribe((ciTypeRes) => {
			let labelString = '';
			for (const [index, ciType] of ciTypeRes.entries()) {
				labelString += ciType.label;
				if (ciTypeRes && ciTypeRes.length - 1 != index) {
					labelString += ',';
				}
			}
			this.LabelsService.getLabels().subscribe((labels) => {
				this.labels = { ...this.labels, ...labels };
				this.isAvailableCiLoading = false;
			});
			this.availableCiTypes = ciTypeRes;
		});

		this.FilesService.getAllowedMimeType().subscribe((allowedMimeTypes) => {
			this.allowedMimeTypes = allowedMimeTypes;
			this.allowedMimeTypeTip += `${this.labels.lbl_tipos_arquivo_permitidos}: `;
			for (const [index, mt] of this.allowedMimeTypes.entries()) {
				this.allowedMimeTypeStr += `${mt.mime_type},`;
				this.allowedMimeTypeTip += `${mt.extension}${index == this.allowedMimeTypes.length - 1 ? '' : ', '}`;
			}
			this.allowedMimeTypeTip += ` ${Math.floor(this.allowedMimeTypes[0].max_file_size)}MB.`;
			this.isLoadingAllowedMimeTypes = false;
		});

		this.RequestFieldFiltersService.getSelectedFilters().subscribe((filters: RequestFieldFilterInterface[]) => {
			if (filters && filters.length > 0) {
				if (this.ProfileService.userData().usertype.includes('analyst')) {
					this.selectedFilterAnalyst = filters[0].selectedFilterAnalyst;
				} else {
					this.selectedFilterEnduser = filters[0].selectedFilterEnduser;
				}
			}
		});

		this.CustomerStrikeService.getStrikeCustomer().subscribe((strikes) => {
			this.threeStrikes = strikes[0].enable_3strikes;
		});

		this.CustomerInformationService.getContractedSolutionAreas().subscribe((data) => {
			this.contractedGroupList = data;
		});

		this.getAllRequestData();
	}

	ngOnDestroy(): void {
		if (this.countDownSlaInterval) {
			clearInterval(this.countDownSlaInterval);
		}
	}

	ngAfterContentChecked() {
		this.cdref.detectChanges();
	}

	getAllRequestData(): void {
		this.ActivatedRoute.params.subscribe((parameters) => {
			if (parameters && !parameters.idRequest) return;

			this.RequestPageService.getRequest(parameters.idRequest).subscribe({
				next: (requestRes) => {
					this.taskManagementService
						.getSolutionAreaByCustomer({ id_customer: requestRes.id_customer })
						.subscribe((solutionAreas) => {
							this.solutionAreas = solutionAreas;
						});

					this.ClassificationService.getClassificationServiceType().subscribe({
						next: (availableServiceTypes) => {
							for (const serviceType of availableServiceTypes) {
								this.availableServiceTypes[serviceType.id] = serviceType.name;
							}
						},
					});

					this.RequestPageService.getAllStatus().subscribe({
						next: (allStatus) => {
							this.allStatus = allStatus;
							for (const status of this.allStatus) {
								this.allStatusAsLabel[status.status] = status.label;
							}
							this.isLoadingAllStatus = false;
						},
					});

					this.RequestPageService.getAvailableStatus(parameters.idRequest).subscribe({
						next: (availableStatus) => {
							this.availableStatus = availableStatus;
							this.isLoadingAvailableStatus = false;
						},
					});

					this.RequestPageService.getEmailStatus(parameters.idRequest).subscribe({
						next: (data) => {
							this.availableEmailStatus = data;
						},
					});

					this.RequestCustomfieldService.getCustomfieldsByRequest(parameters.idRequest)
						.subscribe({
							next: (customfieldRes) => {
								this.customfields = customfieldRes;
								this.customfieldsMemory = $.extend(true, [], this.customfields);
								this.addTip();
							},
						})
						.add(() => {
							this.isCustomfieldLoading = false;
						});

					this.RequestPageService.getAnalystList(parameters.idRequest)
						.subscribe({
							next: (availableAnalystsRes) => {
								this.availableAnalysts = availableAnalystsRes;
							},
						})
						.add(() => {
							this.isLoadingAnalysts = false;
						});

					this.classificationOptions.selectedCustomer = requestRes.id_customer;
					this.relatedRequestOptions.initial_enduser = requestRes.enduser;
					this.relatedRequestOptions.initial_id_enduser = requestRes.id_enduser;
					this.relatedRequestOptions.initial_related_request_id = requestRes.id;
					this.requestData = requestRes;
					this.getTaskOptions(this.requestData.id);

					for (const [index, ci] of this.requestData.relatedCis.entries()) {
						this.bondedCisArr.push(ci.id);
					}

					const temporaryClassificationIds: any = {};
					temporaryClassificationIds['idSolutionArea'] = this.requestData.id_solution_area;
					temporaryClassificationIds['idServiceType'] = this.requestData.id_service_type;
					temporaryClassificationIds['idScope'] = this.requestData.id_scope;
					temporaryClassificationIds['idCategory'] = this.requestData.id_category;
					temporaryClassificationIds['idTopic'] = this.requestData.id_topic;
					temporaryClassificationIds['idImpact'] = this.requestData.impact;
					temporaryClassificationIds['idUrgency'] = this.requestData.urgency;
					temporaryClassificationIds['idSeverity'] = this.requestData.severity;
					this.classificationIds = temporaryClassificationIds;

					this.loadDataAndTemplates(this.classificationOptions.selectedCustomer);

					// this.selectedEmailCCUserIAC.value = requestRes.email_enduser;
					// this.selectedEmailCCUserIAC.name = requestRes.email_enduser;
					this.selectedOption = this.requestData.count_strikes;
					this.setUserView();
					this.callSearchKbSolution();
					this.getRequestTemplate();

					this.hasMatchingActiveGroup = this.contractedGroupList.some(
						(group) => group.group_name === this.requestData.solution_area && group.active === 1
					);

					if (
						this.hasMatchingActiveGroup &&
						this.userView === this.userViewTypes.ENDUSER &&
						this.closedStatuses.includes(this.requestData.status)
					) {
						this.newLog.status = 'Re-Activate';
						this.newLog.duration = '00:01';
						this.newLog.email_cc = '';
						this.newLog.sendEmailAttachEnduser = false;
						this.reactivationRequestButton = true;
					}

					//Caso chamado seja confidencial
					this.isLoadingAvailableUsers = true;
					forkJoin([
						this.RequestOpeningService.getAvailableConfidentialUsers(),
						this.RequestPageService.getConfidentialUsers(this.requestData.id),
					]).subscribe({
						next: (forkRes) => {
							const availableUsers = forkRes[0];
							const confidentialUsers = forkRes[1];
							this.customConfidentialForm.values = [];
							this.customConfidentialForm.rawValues = [];
							this.customConfidentialForm.items = [];

							for (const user of availableUsers) {
								const userGeneric: genericFormI = new genericFormI('item');
								userGeneric.id = user.id;
								userGeneric.name = user.fullName;
								userGeneric.label = user.fullName;
								userGeneric.values[0] = user.id;
								if (confidentialUsers.includes(user.id)) {
									this.customConfidentialForm.values.push(userGeneric);
									this.customConfidentialForm.rawValues.push(user.id);
								} else {
									this.customConfidentialForm.items.push(userGeneric);
								}
							}
						},
					});

					this.verifyUserTask();

					if (this.countDownSlaInterval) clearInterval(this.countDownSlaInterval);

					this.countDownSlaInterval = setInterval(() => {
						this.countDownSla();
					}, 1000);
					this.getRequestTabs();

					if (
						(!this.requestData.changePlan || this.requestData.changePlan.length === 0) &&
						this.requestData.service_type === 'Change'
					) {
						const newEmptyChangePlan: changePlanInterface = {
							fileAttach: '',
							riskAssessement: '',
							fallback: '',
							urgency: 1,
							impact: 1,
							risk: 1,
							category: 1,
							priority: 4,
						};
						this.requestData.changePlan.push(newEmptyChangePlan);
					}

					this.getChangePlanDates();

					if (this.requestData.service_type === 'Incident' || this.requestData.service_type === 'Problem') {
						this.isLoadingCrisisTeamForm = true;
						this.RequestPageService.getCrisisTeamForm(this.requestData.id).subscribe({
							next: (crisisForm) => {
								this.crisisTeamForm = crisisForm;
							},
							complete: () => {
								this.isLoadingCrisisTeamForm = false;
							},
						});
					}

					for (const element of this.requestData.tasks) {
						this.RequestPageService.getCheckSlaTask({
							taskId: element.id_task,
							requestId: this.requestData.id,
							serviceType: this.requestData.service_type,
						}).subscribe((checkSlaTask) => {
							if (checkSlaTask.length > 0) {
								if (element.subrequest_id == '') {
									this.createRequestFromTask(element.id_task);
									this.newSubRequestCreated = true;
								}
								if (this.newSubRequestCreated) {
									this.RequestPageService.getRequest(parameters.idRequest).subscribe((requestResTasks) => {
										// Mapeia os novos dados e preserva o valor de 'show_buttons' das tarefas existentes
										this.requestData.tasks = requestResTasks.tasks.map((newTask) => {
											const existingTask = this.requestData.tasks.find((task) => task.id_task === newTask.id_task);

											// Se a tarefa já existe, preserva o valor de 'show_buttons'
											if (existingTask) {
												newTask.show_buttons = existingTask.show_buttons;
											}

											return newTask;
										});
									});
								}
							}
						});
					}

					// Verificar se o requestData.status é 'Waiting for Approval' e se o usuário tem uma das permissões
					this.isWaitingForApproval =
						this.requestData.status === 'Waiting for Approval' &&
						(this.ProfileService.userData().permission.includes('individual_reclassification_waiting_approval') ||
							this.ProfileService.userData().permission.includes('driver_reclassification_waiting_approval'))
							? true
							: false;

					this.isLoadingTask = false;

					this.requestDataMemory = $.extend(true, {}, this.requestData);
					this.isRequestPageLoading = false;

					setTimeout(() => {
						for (const domElement of Array.from(document.querySelectorAll('.start-open'))) {
							this.collapseContent(<HTMLElement>domElement);
						}
					}, 1000);
				},
				complete: () => {
					this.RequestOpeningService.getAvailableOptions({ idCustomer: this.requestData.id_customer }).subscribe({
						next: (data) => {
							this.affectedLocations = data.affectedLocations;
						},
						error: (error) => {
							console.error('Erro ao carregar opções:', error);
						},
					});
				},
				error: () => {
					this.NotificationService.setNotificationMessage(this.labels.lbl_chamado_nao_encontrado);
					this.redirectTo('/request');
				},
			});
		});
	}

	getLogPrimaryNotes(notes: string): string {
		if (!notes) return '';

		return notes
			.replace(this.logEmailInfoRegex, '')
			.replaceAll(/(<br\s*\/?>\s*)+$/gi, '')
			.trim();
	}

	getLogInfoNote(notes: string): string {
		if (!notes) return '';

		const match = notes.match(this.logEmailInfoRegex);
		return match ? match[1].trim() : '';
	}

	// Método para formatar a data no formato YYYY-MM-DD, sem alterar para o horário local
	formatDate(dateTimeString: string): string {
		if (!dateTimeString) return '';

		// Adiciona 'Z' para garantir que o JavaScript trate como UTC
		const utcDateString = dateTimeString + 'Z'; // Assume que a data está em UTC

		const parsedDate = new Date(utcDateString); // Converte a string para objeto Date

		// Força a hora para o fuso horário UTC, sem alterar para o horário local
		const year = parsedDate.getUTCFullYear();
		const month = String(parsedDate.getUTCMonth() + 1).padStart(2, '0');
		const day = String(parsedDate.getUTCDate()).padStart(2, '0');

		return `${year}-${month}-${day}`;
	}

	// Método para formatar a hora no formato HH:MM, sem alterar o fuso horário
	formatTime(dateTimeString: string): string {
		if (!dateTimeString) return '';

		// Adiciona 'Z' para garantir que o JavaScript trate como UTC
		const utcDateString = dateTimeString + 'Z'; // Assume que a data está em UTC

		const parsedDate = new Date(utcDateString);

		// Força a hora para o fuso horário UTC, sem alterar para o horário local
		const hours = String(parsedDate.getUTCHours()).padStart(2, '0');
		const minutes = String(parsedDate.getUTCMinutes()).padStart(2, '0');

		return `${hours}:${minutes}`;
	}

	getChangePlanDates(): void {
		// Implementação das Datas do Plano de Mudança
		this.RequestPageService.getChangePlan(this.requestData.id).subscribe((resp) => {
			this.requestData.changePlanDates = [];
			if (resp && resp.length > 0) {
				const data = resp[0];
				// Mapeando as datas
				this.changePlanDates.startDateAgreed = this.formatDate(data?.totalChangeDate?.start_date);
				this.changePlanDates.startTimeAgreed = this.formatTime(data?.totalChangeDate?.start_date);
				this.changePlanDates.endDateAgreed = this.formatDate(data?.totalChangeDate?.end_date);
				this.changePlanDates.endTimeAgreed = this.formatTime(data?.totalChangeDate?.end_date);

				this.changePlanDates.execStartDate = this.formatDate(data?.executionChangeDate?.start_date);
				this.changePlanDates.execStartTime = this.formatTime(data?.executionChangeDate?.start_date);
				this.changePlanDates.execEndDate = this.formatDate(data?.executionChangeDate?.end_date);
				this.changePlanDates.execEndTime = this.formatTime(data?.executionChangeDate?.end_date);

				this.changePlanDates.unavailabilityStartDate = this.formatDate(data?.indispMudanca?.start_date);
				this.changePlanDates.unavailabilityStartTime = this.formatTime(data?.indispMudanca?.start_date);
				this.changePlanDates.unavailabilityEndDate = this.formatDate(data?.indispMudanca?.end_date);
				this.changePlanDates.unavailabilityEndTime = this.formatTime(data?.indispMudanca?.end_date);
			}
		});
	}

	updateChangePlanDates(): void {
		this.validationErrors = {}; // Reseta os erros antes de enviar
		this.RequestPageService.updateChangePlanDates(this.requestData.id, this.changePlanDates).subscribe({
			next: () => {
				this.NotificationService.setNotificationMessage(this.labels.lbl_successful_updated);
				this.validationErrors = {}; // Reseta os erros após sucesso
				this.RequestPageService.getLog(this.requestData.id).subscribe((logs) => {
					this.requestData.logs = logs;
				});
				this.getAllRequestData();
				this.NotificationService.setNotificationMessage(this.labels.lbl_action_reload_page);
			},
			error: (error) => {
				// Se houver um erro de validação e ExtendedInfo estiver presente
				if (error.error && error.error.ExtendedInfo) {
					const field = error.error.ExtendedInfo; // Nome do campo retornado pelo backend
					const fieldsValidate = [];
					fieldsValidate.push(field);
					for (const fieldValue of fieldsValidate) {
						this.validationErrors[fieldValue] = true; // Marca o campo como inválido
					}
				}
				console.error('Erro ao atualizar as datas do plano de mudança:', error);
				this.NotificationService.setNotificationMessage(error.error?.Message);
			},
		});
	}

	resetChangePlanDates() {
		this.changePlanDates.startDateAgreed = '';
		this.changePlanDates.startTimeAgreed = '';
		this.changePlanDates.endDateAgreed = '';
		this.changePlanDates.endTimeAgreed = '';

		this.changePlanDates.execStartDate = '';
		this.changePlanDates.execStartTime = '';
		this.changePlanDates.execEndDate = '';
		this.changePlanDates.execEndTime = '';

		this.changePlanDates.unavailabilityStartDate = '';
		this.changePlanDates.unavailabilityStartTime = '';
		this.changePlanDates.unavailabilityEndDate = '';
		this.changePlanDates.unavailabilityEndTime = '';
	}

	// Criado para pegar o template utilizado no chamado
	getRequestTemplate(): void {
		if (!this.requestData.id_solution_area || !this.requestData.id_topic) return;
		this.RequestOpeningService.getRequestTemplate(this.requestData.id_solution_area, this.requestData.id_topic).subscribe((res) => {
			if (res.length > 0) {
				const idTemplateRequest = res[0];
				this.RequestOpeningService.getTemplate(idTemplateRequest).subscribe((requestTemplateRes) => {
					this.requestTemplate = requestTemplateRes;
					this.isDescriptionRequired = requestTemplateRes.description_required;
				});
			}
		});
	}

	getRequestTabs(): void {
		this.tabs = [
			{ tabName: this.labels.lbl_chamado_acompanhamento, changeTab: 'Acompanhamento' },
			// {"tabName":this.labels.lbl_historico_de_chamado, "changeTab":"HistoricRequest"},
		];
		if (this.requestData.tasks?.length > 0) {
			this.tabs.push({ tabName: this.labels.lbl_chamado_tarefas, changeTab: 'Tasks' });
		}
		if (this.requestData.child_requests?.length > 0) {
			this.tabs.push({ tabName: this.labels.lbl_chamado_relacionados, changeTab: 'relatedRequests' });
		}
		if (this.userView === this.userViewTypes.ANALYST) {
			this.tabs.push({ tabName: this.labels.lbl_chamado_historico_grupos, changeTab: 'Historico' });

			if (this.requestData.relatedCis?.length > 0) {
				this.tabs.push({ tabName: this.labels.lbl_cmdb_cis_relacionados, changeTab: 'CI' });
			}
			if (this.requestData.relatedInconsistency) {
				this.tabs.push({ tabName: this.labels.lbl_geral_inconsistencias, changeTab: 'inconsistency' });
			}
			if (this.ProfileService.userData().permission.includes('access_kb')) {
				this.tabs.push({ tabName: this.labels.lbl_geral_artigos_relacionados, changeTab: 'relatedArticles' });
			}
			this.tabs.push({ tabName: this.labels.lbl_geral_opcoes_administrativas, changeTab: 'extraOptions' });
		}
		if (this.userView === this.userViewTypes.ENDUSER && this.ProfileService.userData().fullName == this.requestData.enduser) {
			this.tabs.push({ tabName: this.labels.lbl_geral_opcoes_administrativas, changeTab: 'extraOptions' });
		}
		if (this.requestData.attached_files && this.requestData.attached_files.length > 0) {
			this.tabs.push({ tabName: this.labels.lbl_geral_anexo, changeTab: 'attachments' });
		}

		if (
			this.requestData.service_type === 'Change Plan' &&
			this.requestData.business_hours === '2' &&
			this.userView === this.userViewTypes.ANALYST
		) {
			this.tabs.push({ tabName: 'Change Plan', changeTab: 'Change Plan' });
		}
		//this.tabs.push();
		if (
			this.requestData.service_type === 'Change' &&
			this.requestData.business_hours === '2' &&
			this.userView === this.userViewTypes.ANALYST
		) {
			this.tabs.push({ tabName: this.labels.lbl_geral_plano_mudanca, changeTab: 'Change' });
		}

		if (this.requestData.high_severity == true) {
			this.tabs.push({
				tabName: this.labels.lbl_time_de_crise,
				changeTab: 'crisisTeam',
			});
		}

		if (this.tabs && this.tabs.length > 2) {
			this.tabs.splice(2, 0, { tabName: '+', changeTab: 'Plus' });
		}

		this.tabs.push({
			tabName: 'Exportar Chamado',
			changeTab: 'exportRequest',
			onClick: () => {
				this.exportPDF();
			},
		});
	}

	saveRequestChanges(): void {
		if (this.isSavingLoading) return;

		let canUpdateCustomfields = true;
		this.isSavingLoading = true;

		this.requestCustomfieldComponent?.verifyCustomfieldValues(true);
		if (!this.requestCustomfieldComponent) {
			this.verifyCustomfieldValues();
		}
		if (this._isCustomfieldFulfilled == false) {
			canUpdateCustomfields = false;
		}

		if (this.requestData.summary.trim() === '') {
			this.NotificationService.setNotificationMessage(this.labels.lbl_sumario_nao_pode_ser_vazio);
			this.isSavingLoading = false;
			return;
		}
		if (
			(!this.requestData.description || (this.requestData.description && this.requestData.description.trim() === '')) &&
			this.requestTemplate &&
			this.requestTemplate.description_required
		) {
			this.NotificationService.setNotificationMessage(this.labels.lbl_geral_descricao_justificativa_obrigatoria);
			this.isSavingLoading = false;
			return;
		}
		if (
			(this.reverseClassification && !this.requestData.id_topic) ||
			(!this.reverseClassification && !this.requestData.id_solution_area) ||
			!this.isClassificationFulfilled
		) {
			this.NotificationService.setNotificationMessage(this.labels.lbl_preencha_todos_campos_classificar);
			this.isSavingLoading = false;
			return;
		}
		if (!canUpdateCustomfields || (this.isRequestBeingReclassified && !this.reclassifyReason)) {
			this.NotificationService.setNotificationMessage(this.labels.lbl_preencha_todos_campos_customizados);
			this.isSavingLoading = false;
			return;
		}
		if (
			this.requestData &&
			this.requestData.parent_request &&
			this.requestData.parent_request.id.toString().trim() != '' &&
			!new RegExp(String.raw`^(0|[1-9]\d*){7,9}$`).test(this.requestData.parent_request.id)
		) {
			this.NotificationService.setNotificationMessage(this.labels.lbl_numero_de_chamado_pai_invalido);
			this.isSavingLoading = false;
			return;
		}
		if (this.requestData.id_analyst === '-1' || this.requestData.id_analyst === '') {
			this.requestData.id_analyst = this.availableAnalysts[0].id;
			this.requestData.analyst = this.availableAnalysts[0].fullName;
		}

		// Verificação de campos customizados
		if (this.customfields && this.customfields.length > 0) {
			for (let index = 0; index < this.customfields.length; index++) {
				const customfield = this.customfields[index];

				// Verifica se o valor está preenchido e atualiza isRequestBeingEdited
				if (customfield.values[0] && customfield.values[0].length > 0) {
					this.isRequestBeingEdited = true;
				}

				// Verificar se o valor excede 255 caracteres (exceto json_dynamic que guarda JSON)
				if (customfield.rawInputType !== 'json_dynamic' && customfield.values[0] && customfield.values[0].length > 255) {
					this.NotificationService.setNotificationMessage(this.labels.lbl_geral_max_caracteres_campo_customizado);
					this.isSavingLoading = false; // Resetar o estado de carregamento
					return; // Parar o fluxo se o campo exceder o limite de caracteres
				}
			}
		}

		if (this.isClassificationFulfilled) {
			this.isClassificationFulfilled = false;
			this.isRequestBeingReclassified = false;
		}

		if (this.requestData.idAffectedLocation == '' || this.requestData.idAffectedLocation == undefined) {
			this.requestData.idAffectedLocation = this.requestData.idlocation;
		}

		this.isLoadingAvailableStatus = true;

		const requestUpdatePayload: RequestUpdatePayload = {
			idRequest: this.requestData.id,
			idTopic: this.requestData.id_topic,
			idSolutionArea: this.requestData.id_solution_area,
			urgency: this.requestData.urgency,
			reclassifyReason: this.reclassifyReason,
			changeAnalystToDriver: this.changeAnalystToDriver,
			impact: this.requestData.impact,
			summary: this.requestData.summary,
			description: this.requestData.description,
			relatedRequest: this.requestData.parent_request.id,
			idAnalyst: this.requestData.id_analyst,
			severity: this.requestData.severity,
			confidential: this.requestData.confidential,
			customConfidentialUsers: this.customConfidentialForm.rawValues ? this.customConfidentialForm.rawValues : [],
			serviceType: this.requestData.service_type,
			riskType: this.requestData.riskType,
			idAffectedLocation: this.requestData.idAffectedLocation,
			idlocation: this.requestData.idlocation,
		};

		this.RequestPageService.updateRequestData(requestUpdatePayload).subscribe(
			(requestRes) => {
				this.isSavingLoading = false;
				this.isRequestBeingEdited = false;
				this.isLoadingAvailableStatus = false;
				this.changeAnalystToDriver = false;
				this.canSetDriver = false;

				this.requestDataMemory.summary = this.requestData.summary;
				this.requestDataMemory.description = this.requestData.description;

				//class
				this.requestDataMemory.service_type = '' + this.requestData.service_type;
				this.requestDataMemory.id_scope = '' + this.requestData.id_scope;
				this.requestDataMemory.id_category = '' + this.requestData.id_category;
				this.requestDataMemory.id_topic = '' + this.requestData.id_topic;
				this.requestDataMemory.id_solution_area = '' + this.requestData.id_solution_area;
				this.requestDataMemory.impact = '' + this.requestData.impact;
				this.requestDataMemory.urgency = '' + this.requestData.urgency;
				this.requestDataMemory.severity = '' + this.requestData.severity;
				this.requestDataMemory.riskType = '' + this.requestData.riskType;
				this.reclassifyReason = '';
				this.requestTemplateId = undefined;
				this.customConfidentialFormMemory = JSON.parse(JSON.stringify(this.customConfidentialForm));

				if (this.requestData.id_analyst != this.requestDataMemory.id_analyst) {
					for (let index = 0; index < this.availableAnalysts.length; index++) {
						const temporaryAnalyst = this.availableAnalysts[index];
						if (temporaryAnalyst.id != this.requestData.id_analyst) continue;

						this.requestData.analyst = temporaryAnalyst.fullName;
						this.requestData.email_analyst = temporaryAnalyst.email;
						this.requestData.id_analyst = temporaryAnalyst.id;

						this.requestDataMemory.analyst = this.requestData.analyst;
						this.requestDataMemory.email_analyst = this.requestData.email_analyst;
						this.requestDataMemory.id_analyst = this.requestData.id_analyst;
					}
				}
				this.requestDataMemory.id_analyst = '' + this.requestData.id_analyst;

				if (requestRes.relatedRequest && requestRes.relatedRequest === 'Not found') {
					this.requestData.parent_request.id = '-1';
					setTimeout(() => {
						this.requestData.parent_request.id = '';
					}, 5000);
				} else if (
					this.requestDataMemory &&
					this.requestDataMemory.parent_request &&
					this.requestDataMemory.parent_request.id != this.requestData.parent_request.id
				) {
					this.requestDataMemory.parent_request.id = this.requestData.parent_request.id;
				}

				//If it don't have customfields to update, we can set last info update here,
				//however, if it has customfields, this will be done after the customfield requests
				if (!this.customfields || this.customfields.length === 0) {
					this.RequestPageService.getLog(this.requestData.id).subscribe((logs) => {
						this.requestData.logs = logs;
					});
					this.getAllRequestData();
					this.NotificationService.setNotificationMessage(this.labels.lbl_salvo_com_sucesso);
				}

				this.getAllRequestData();
			},
			() => {
				this.isSavingLoading = false;
				this.isRequestBeingEdited = false;
				this.isLoadingAvailableStatus = false;
				this.requestTemplateId = undefined;
				this.changeAnalystToDriver = false;
				this.canSetDriver = false;
				this.NotificationService.setNotificationMessage(this.labels.lbl_erro_ao_salvar);
				this.getAllRequestData();
			}
		);

		if (this.customfields && this.customfields.length > 0) {
			const cfToDelete: genericFormInterface[] = [];
			const cfToUpdate: genericFormInterface[] = [];
			const cfToCreate: genericFormInterface[] = [];
			const cfToUpload: genericFormInterface[] = [];
			const temporaryCustomfield = [...this.customfields];
			const temporaryDicCustomfieldMemory = {};
			for (const cfMemory of this.customfieldsMemory) {
				temporaryDicCustomfieldMemory[cfMemory.id] = cfMemory;
			}

			for (let index = 0; index < temporaryCustomfield.length; index++) {
				const cf = temporaryCustomfield[index];
				if (cf.rawInputType == 'attachment') {
					if (cf.values[0] instanceof Object) {
						cfToUpload.push(cf);
					}
					temporaryDicCustomfieldMemory[cf.id] = undefined;
					temporaryCustomfield.shift();
					index -= 1;
				} else if (temporaryDicCustomfieldMemory[cf.id]) {
					//If has in memory and keep existing, it's an update
					cfToUpdate.push(cf);
					temporaryDicCustomfieldMemory[cf.id] = undefined;
					temporaryCustomfield.shift();
					index -= 1;
				} else {
					//If has actually and not in memory, it's a new field
					cfToCreate.push(cf);
					temporaryCustomfield.shift();
					index -= 1;
				}
			}

			//If has in memory and not exist anymore, it's a to delete field
			for (const cfMemory of Object.keys(temporaryDicCustomfieldMemory)) {
				if (temporaryDicCustomfieldMemory[cfMemory] != undefined) {
					cfToDelete.push(temporaryDicCustomfieldMemory[cfMemory]);
				}
			}

			for (const field of cfToUpload) {
				this.newLog.analyst = this.ProfileService.userData().fullName;
				this.newLog.duration = '00:00';
				this.newLog.file_log = field.values;
				this.newLog.log_date = new ShkDate().getDate();
				this.newLog.notes = `${this.labels.lbl_campo_customizado_anexo} <b>${field.name}</b>.`;
				this.newLog.idLog = 'NEW';
				this.newLog.status = 'Custom Field Update';
				this.addLog();
			}

			forkJoin([
				this.RequestPageService.postCustomfields(cfToCreate, this.requestData.id),
				this.RequestPageService.putCustomfields(cfToUpdate, this.requestData.id),
				this.RequestPageService.deleteCustomfields(cfToDelete, this.requestData.id),
			]).subscribe((res) => {
				this.RequestPageService.getLog(this.requestData.id).subscribe((logs) => {
					this.requestData.logs = logs;
				});
				this.customfieldsMemory = [...this.customfields];
				this.NotificationService.setNotificationMessage(this.labels.lbl_salvo_com_sucesso);
				this.getAllRequestData();
			});
		}
	}

	resetRequest(): void {
		this.isClassificationFulfilled = false;
		this.isRequestBeingReclassified = false;
		this.isCustomfieldReclassified = false;

		this.requestData.service_type = '' + this.requestDataMemory.service_type;
		this.requestData.scope = '' + this.requestDataMemory.scope;
		this.requestData.category = '' + this.requestDataMemory.category;
		this.requestData.topic = '' + this.requestDataMemory.topic;
		this.requestData.solution_area = '' + this.requestDataMemory.solution_area;
		this.requestData.severity = '' + this.requestDataMemory.severity;
		this.requestData.analyst = '' + this.requestDataMemory.analyst;

		this.requestData.id_service_type = '' + this.requestDataMemory.id_service_type;
		this.requestData.id_scope = '' + this.requestDataMemory.id_scope;
		this.requestData.id_category = '' + this.requestDataMemory.id_category;
		this.requestData.id_topic = '' + this.requestDataMemory.id_topic;
		this.requestData.id_solution_area = '' + this.requestDataMemory.id_solution_area;
		this.requestData.id_severity = '' + this.requestDataMemory.id_severity;
		this.requestData.id_analyst = '' + this.requestDataMemory.id_analyst;

		this.reclassifyReason = '';
		this.requestTemplateId = undefined;

		this.requestData.summary = '' + [...this.requestDataMemory.summary];
		this.requestData.description = '' + [...this.requestDataMemory.description];
		this.customfields = $.extend(true, [], this.customfieldsMemory);
		this.customConfidentialForm = this.customConfidentialFormMemory
			? JSON.parse(JSON.stringify(this.customConfidentialFormMemory))
			: {};

		this.changeAnalystToDriver = false;
		this.canSetDriver = false;
	}

	cancelRequest(): void {
		this.newLog.status = 'Cancelled';
		this.newLog.duration = '00:01';
		this.newLog.notes = `${this.labels['lbl_geral_motivo_cancelamento']}: \n${this.newLog.notes}`;
		this.addLog();
		this.cancelRequestModal.closeModal();
	}

	formatDateToValue(dateString: string): string {
		const date = new Date(dateString);
		let formatedDate = '';
		formatedDate += date.getFullYear() + '-';

		if (date.getMonth() + 1 <= 9) {
			formatedDate += '0';
		}
		formatedDate += date.getMonth() + 1 + '-';

		if (date.getDate() <= 9) {
			formatedDate += '0';
		}
		formatedDate += date.getDate();

		return formatedDate;
	}

	formatDuration(dateString: string): string {
		const date = new Date(dateString);
		let formatedDate = '';

		if (date.getHours() <= 9) {
			formatedDate += '0';
		}
		formatedDate += date.getHours() + 'h';
		if (date.getMinutes() <= 9) {
			formatedDate += '0';
		}
		formatedDate += date.getMinutes() + 'm';

		return formatedDate;
	}

	formatMinutesToHour(minutes: unknown): string {
		const numberMinutes = <number>minutes;
		if (numberMinutes <= 0) {
			return '00h00m';
		}

		const hour = Math.trunc(numberMinutes / 60);
		const remainingMinutes = Math.trunc(numberMinutes % 60);

		return `${hour}h${remainingMinutes < 10 ? '0' + remainingMinutes : remainingMinutes}m`;
	}

	formatSecondsToHour(seconds: any): string {
		if (seconds <= 0) return '00h00m';

		seconds = Number.parseInt(seconds);
		const minutes = Math.trunc((seconds / 60) % 60);
		const hours = Math.trunc(seconds / 60 / 60);

		return `${hours}h${minutes < 10 ? '0' + minutes : minutes}m`;
	}

	formatAttachPath(filePath: string): string {
		if (filePath) {
			let splitedFilePath = [];
			splitedFilePath = filePath.includes('\\') ? filePath.split('\\') : filePath.split('/');

			return splitedFilePath.at(-1);
		}

		return '';
	}

	verifyCustomfieldValues(): void {
		this._isCustomfieldFulfilled = true;
		for (const customfield of this.customfields) {
			//As verificações de campos obrigatórios deverão ser somente na abertura ou no fechamento do chamado.
			//Reclassificações ou trocas de analista não devem ser consideradas. ab#11235
			if (
				(this.requestData.status === 'Solved' || this.newLog.status === 'Solved') &&
				customfield.hidden == false &&
				//e caso seja campo obrigatório
				(customfield.required.toString() == '1' || customfield.required.toString() == '2') &&
				//e não esteja vazio
				(!customfield.values[0] || customfield.values[0].toString() == '-1' || customfield.values[0].toString().trim() == '')
			) {
				this._isCustomfieldFulfilled = false;
			}
		}
	}

	updateCountStrike(reloadData: boolean = true): void {
		if (this.applyStrike) {
			switch (this.selectedOption) {
				case '0': {
					this.selectedOption = '1';
					break;
				}
				case '1': {
					this.selectedOption = '2';
					break;
				}
				case '2': {
					this.selectedOption = '3';
					break;
				}
				default: {
					this.selectedOption;
					break;
				}
			}
		}

		if (this.newLog.status !== 'Waiting User') {
			this.selectedOption = '0';
		}

		if (this.newLog.status === 'Waiting User' && !this.applyStrike) {
			this.selectedOption = '0';
		}

		this.RequestPageService.updateCountStrike(this.requestData.id, this.selectedOption)
			.subscribe(
				() => {
					this.requestData.count_strikes = this.selectedOption;
				},
				(erro) => {
					if (
						erro.error.Message === 'The amount of strike per day has already been made' ||
						erro.error.Message === 'The strike range is still active'
					) {
						this.NotificationService.setNotificationMessage(
							this.labels.lbl_quantidade_strikes_por_dia_atingida_ou_intervalo_permitido
						);
						this.selectedOption = this.requestData.count_strikes;
					}
				}
			)
			.add(() => {
				if (reloadData) {
					this.getAllRequestData();
				}
			});
	}

	validateDatesChange() {
		this.RequestPageService.getChangePlan(this.requestData.id).subscribe((resp) => {
			this.validationErrors = {}; // limpa os erros anteriores
			this.missingFields = [];

			let hasMissingFields = false; // flag global

			resp.forEach((item: any) => {
				if (!item.totalChangeDate?.start_date) {
					this.missingFields.push('startDateAgreed');
					this.validationErrors['startDateAgreed'] = true;
					hasMissingFields = true;
				}

				if (!item.totalChangeDate?.end_date) {
					this.missingFields.push('endDateAgreed');
					this.validationErrors['endDateAgreed'] = true;
					hasMissingFields = true;
				}

				if (!item.executionChangeDate?.start_date) {
					this.missingFields.push('execution_start_date');
					this.validationErrors['execStartDate'] = true;
					hasMissingFields = true;
				}

				if (!item.executionChangeDate?.end_date) {
					this.missingFields.push('execution_end_date');
					this.validationErrors['execEndDate'] = true;
					hasMissingFields = true;
				}

				if (!item.indispMudanca?.start_date) {
					this.missingFields.push('unavailability_start_date');
					this.validationErrors['unavailabilityStartDate'] = true;
					hasMissingFields = true;
				}

				if (!item.indispMudanca?.end_date) {
					this.missingFields.push('unavailability_end_date');
					this.validationErrors['unavailabilityEndDate'] = true;
					hasMissingFields = true;
				}

				// Define se está faltando alguma data ou não
				this.isDatesChangePlanMissing = hasMissingFields;
			});
		});
	}

	addLog(): void {
		if (this.isSendingLog) return;
		//Não permitir adicionar log caso chamado esteja sendo editado. Pode ocasionar erros onde salva campos obrigatórios em branco
		if (this.isRequestBeingEdited) {
			return this.NotificationService.setNotificationMessage(this.labels.lbl_geral_unsaved_changes_form);
		}

		const durationRegex = new RegExp(String.raw`^\d\d:\d\d$`);
		const emailRegex = new RegExp('^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$');
		const emailListRegex = new RegExp(
			String.raw`^\s*([A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,})(\s*[;,]\s*[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,})*\s*$`
		);
		this.verifyCustomfieldValues();

		const isEmptyStatus = this.newLog.status.trim() === '';
		const isSolvedStatus = this.newLog.status === 'Solved';
		const isOverdueIncident = isSolvedStatus && this.requestData.service_type === 'Incident' && this.isLimitDateOver();

		//condição para analysts
		if (this.userView === this.userViewTypes.ANALYST) {
			if (isEmptyStatus) {
				return this.NotificationService.setNotificationMessage(this.labels.lbl_por_favor_selecione_status);
				//chamado não pode ser encerrado caso tenha campos customizados obrigatórios vazios
			} else if (isSolvedStatus && !this._isCustomfieldFulfilled) {
				this._isCustomfieldFulfilled = true;
				return this.NotificationService.setNotificationMessage(this.labels.lbl_geral_preencha_campo_obrigatorio);
				//informar motivo do atraso de encerramento do chamado
			} else if (isOverdueIncident && this.newLog.overdueReason.trim() === '') {
				return this.NotificationService.setNotificationMessage(this.labels.lbl_motivo_atraso);
				//log sem tempo de duração
			} else if (this.newLog.duration.trim() === '' || !durationRegex.test(this.newLog.duration)) {
				return this.NotificationService.setNotificationMessage(this.labels.lbl_preencha_duracao);
			} else if (this.requestData.service_type === 'Change' && this.newLog.status === 'Solved') {
				this.validateDatesChange();
				if (this.isDatesChangePlanMissing)
					return this.NotificationService.setNotificationMessage(this.labels.lbl_geral_preencher_datas_plano_para_fechar);
			}

			//condição para endusers
		} else if (this.userView === this.userViewTypes.ENDUSER && this.hasMatchingActiveGroup === false) {
			this.newLog.status = 'Enduser Feedback';
		}

		this.RequestPageService.getRequest(this.requestData.id).subscribe((requestRes) => {
			if (this.newLog.notes.trim() === '') {
				this.NotificationService.setNotificationMessage(this.labels.lbl_insert_commentary_to_publish_log);
			} else if (
				requestRes.active == '0' &&
				!['Enduser Feedback', 'Internal Comment', 'Re-Activate'].includes(this.newLog.status) &&
				requestRes.status == 'Solved'
			) {
				this.NotificationService.setNotificationMessage(this.labels.lbl_chamado_ja_fechado);
			} else if (requestRes.active == '1' && ['Re-Activate'].includes(this.newLog.status)) {
				this.NotificationService.setNotificationMessage(this.labels.lbl_chamado_ja_aberto);
			} else {
				// this.NotificationService.setNotificationMessage(this.labels.lbl_log_publicada);
				this.isSendingLog = true;
				let resolvedEmailCC = '';
				const typedEmailCC = (this.selectedEmailCCUserIAC.name || '').trim();
				this.newLog.email_cc = '';
				if (this.selectedEmailCCUserIAC.value == this.selectedEmailCCUserIAC.name) {
					resolvedEmailCC = '' + this.selectedEmailCCUserIAC.value;
				} else if (typedEmailCC && emailListRegex.test(typedEmailCC)) {
					resolvedEmailCC = typedEmailCC
						.split(/[,;]/)
						.map((email) => email.trim())
						.filter((email) => emailRegex.test(email))
						.join(',');
				} else if (typedEmailCC) {
					this.isSendingLog = false;
					return this.NotificationService.setNotificationMessage('Informe um e-mail válido para cópia.');
				}
				this.newLog.email_cc = resolvedEmailCC;
				this.RequestPageService.addLog(this.requestData.id, this.newLog).subscribe({
					next: (logRes: logInterface) => {
						if (
							logRes.analyst != this.requestData.email_analyst &&
							this.newLog.status === 'Solved' &&
							this.userView === this.userViewTypes.ANALYST
						) {
							this.requestData.id_analyst = this.ProfileService.userData().idAnalyst;
							this.saveRequestChanges();
						}

						this.isLoadingAvailableStatus = true;
						this.RequestPageService.getAvailableStatus(this.requestData.id).subscribe((availableStatus) => {
							this.availableStatus = availableStatus;
							this.isLoadingAvailableStatus = false;
						});

						this.requestData.duration =
							Number.parseInt(this.requestData.duration.toString()) +
							new Date(logRes.duration).getHours() * 60 +
							new Date(logRes.duration).getMinutes();

						const newLog: logInterface = {
							idLog: logRes.idLog,
							log_date: logRes.log_date,
							notes: logRes.notes,
							status: logRes.status,
							duration: logRes.duration,
							analyst: logRes.analyst,
							overdueReason: '' + this.newLog.overdueReason,
							file_log: [],
						};

						for (const file of this.newLog.file_log) {
							const temporaryFile: mspFileInterface = {
								content: '',
								checkSum: '',
								extension: '',
								file_path: '...',
								mimeType: '',
								name: '',
								size: 0,
							};
							newLog.file_log.push(temporaryFile);
						}

						const temporaryAvailableEmailCUsersIAC = [...this.availableEmailCCUsersIAC];
						this.availableEmailCCUsersIAC = [];
						setTimeout(() => {
							this.availableEmailCCUsersIAC = temporaryAvailableEmailCUsersIAC;
							this.selectedEmailCCUserIAC = { name: '', value: '' };
						}, 0);

						if (this.newLog.file_log.length > 0) {
							this.RequestPageService.sendAttach(logRes.idLog, this.newLog.file_log).subscribe((fileMspRes) => {
								for (const log of this.requestData.logs) {
									if (log.idLog === 'NEW' || log.idLog.toString() == logRes.idLog.toString()) {
										log.file_log = fileMspRes;
										continue;
									}
								}
							});
						}

						if (this.newLog.status == 'Solved' && this.closeChildRequests == true) {
							this.RequestPageService.closeChildRequest(this.requestData.id).subscribe();
						}

						const insertedLog = $.extend(true, {}, newLog);
						this.requestData.logs.unshift(insertedLog);

						if (this.newLog.status != 'Internal Comment' && this.sendEmailEnduser) {
							this.RequestPageService.sendLogEmailEnduser(logRes.idLog, resolvedEmailCC).subscribe(
								(sendResp: any) => {
									if (sendResp?.forwardedEmailLogNote) {
										const currentLog = this.requestData.logs.find(
											(log) => log.idLog?.toString() === logRes.idLog?.toString()
										);

										if (currentLog) {
											currentLog.notes = `${currentLog.notes}${sendResp.forwardedEmailLogNote}`;
										} else {
											insertedLog.notes = `${insertedLog.notes}${sendResp.forwardedEmailLogNote}`;
										}
									}
								}
								// , error => {
								//   this.NotificationService.setNotificationMessage(error.error.Message);
								// }
							);
						}
						if (
							this.userView === this.userViewTypes.ANALYST &&
							this.newLog.status != 'Internal Comment' &&
							this.newLog.status != 'Custom Field Update'
						)
							this.requestData.status = '' + this.newLog.status;
						if (this.newLog.status === 'Cancelled' || this.newLog.status === 'Solved') {
							this.resetRequest();
							this.isRequestBeingEdited = false;
						}
						if (this.newLog.status === 'Re-Activate') {
							if (this.requestData.tasks.length > 0) {
								for (const [index, task] of this.requestData.tasks.entries()) {
									if (task.task_status === 'Rejected') {
										this.newTask = $.extend(true, {}, task);
										this.newTask.task_status = 'Re-Activate';
										this.updateTask(this.newTask.id_task, index);
									}
								}
							} else {
								this.requestData.status = 'In Progress';
							}
						}
						this.newLog = {
							analyst: '',
							duration: '',
							idLog: '',
							log_date: '',
							notes: '',
							status: this.newLog.status,
							overdueReason: '',
							file_log: [],
						};

						this.stopRequestDuration();
						this.updateCountStrike(false);

						this.isModalOpen = false;
						this.isSendingLog = false;

						this.NotificationService.setNotificationMessage(this.labels.lbl_log_publicada);

						if (this.requestData.status === 'Waiting User' && this.availableEmailStatus[0].Email_WaitingUser === 0) {
							this.NotificationService.setNotificationMessage(this.labels.lbl_envio_email_desabilitado);
						}
					},
					complete: () => {
						this.reactivationRequestButton = false;
						this.newLog.status = '';
						this.closeChildRequests = false;
					},
				});
			}
		});
	}

	resetSuperLog(): void {
		this.newSuperLog = {
			analyst: '',
			duration: '',
			idLog: '',
			log_date: '',
			notes: '',
			status: '',
			overdueReason: '',
		};
	}

	setNewSuperLog(log: logInterface): void {
		this.newSuperLog = $.extend(true, {}, log);
	}

	superUpdateLog(idLog: string): void {
		const superLogMemory = $.extend(true, {}, this.newSuperLog);
		const durationRegex = new RegExp(String.raw`^\d\d:\d\d$`);
		if (superLogMemory.duration != '00:00' && durationRegex.test(superLogMemory.duration)) {
			superLogMemory.duration =
				'' +
				new Date().getFullYear() +
				'-' +
				(new Date().getMonth() + 1) +
				'-' +
				new Date().getDate() +
				' ' +
				superLogMemory.duration;
		}
		let logMemory: logInterface;
		for (const [index, log] of this.requestData.logs.entries()) {
			if (log.idLog === idLog) {
				logMemory = $.extend(true, {}, this.requestData.logs[index]);
				this.requestData.logs[index] = superLogMemory;
			}
		}

		this.isSuperEditingLog = false;
		this.resetSuperLog();

		this.RequestPageService.superUpdateLog(superLogMemory).subscribe(
			() => {},
			() => {
				for (const [index, log] of this.requestData.logs.entries()) {
					if (log.idLog === idLog) {
						this.requestData.logs[index] = logMemory;
					}
				}
				this.NotificationService.setNotificationMessage('* Houve um erro na atualização de log.');
			}
		);
	}

	openAnalystsInfoOnGroupChange() {
		const analystInfoElement = document.querySelector<HTMLElement>('#analystInfoCollapsalble');
		setTimeout(() => {
			if (analystInfoElement.classList.contains('active')) {
				this.collapseContent(analystInfoElement);
				setTimeout(() => {
					this.collapseContent(analystInfoElement);
				}, 500);
			} else {
				this.collapseContent(analystInfoElement);
			}
		}, 100);
	}

	setClassification(classification: string): void {
		const requestClassification: requestClassificationInterface = JSON.parse(classification);
		this.requestData.service_type = requestClassification.serviceType[0] ? requestClassification.serviceType[0].name : '';
		this.requestData.id_scope = requestClassification.scope[0] ? requestClassification.scope[0].id : '';
		this.requestData.id_category = requestClassification.category[0] ? requestClassification.category[0].id : '';
		this.requestData.id_topic = requestClassification.topic[0] ? requestClassification.topic[0].id : '';
		this.requestData.id_solution_area = requestClassification.solutionArea[0] ? requestClassification.solutionArea[0].id : '';
		this.requestData.id_impact = requestClassification.severity[0] ? requestClassification.impact[0].id : '';
		this.requestData.id_urgency = requestClassification.severity[0] ? requestClassification.urgency[0].id : '';
		this.requestData.id_severity = requestClassification.severity[0] ? requestClassification.severity[0].id : '';
		//removed risktype
		this.requestData.scope = requestClassification.scope[0] ? requestClassification.scope[0].name : '';
		this.requestData.category = requestClassification.category[0] ? requestClassification.category[0].name : '';
		this.requestData.topic = requestClassification.topic[0] ? requestClassification.topic[0].name : '';
		this.requestData.solution_area = requestClassification.solutionArea[0] ? requestClassification.solutionArea[0].name : '';
		this.requestData.impact = requestClassification.severity[0] ? requestClassification.impact[0].impact : '';
		this.requestData.urgency = requestClassification.severity[0] ? requestClassification.urgency[0].urgency : '';
		this.requestData.severity = requestClassification.severity[0] ? requestClassification.severity[0].severity : '';
		//removed risktype

		//Classificação antiga já com a últipa etapa preenchida
		if (
			!this.isRequestBeingReclassified &&
			((!this.reverseClassification && this.requestData.id_solution_area != '') ||
				(this.reverseClassification && this.requestData.id_topic != ''))
		) {
			this.isClassificationFulfilled = true;
		}

		//Classificação nova mas ainda não foi completamente preenchida
		if (
			this.isRequestBeingReclassified &&
			((!this.reverseClassification && this.requestData.id_solution_area == '') ||
				(this.reverseClassification && this.requestData.id_topic) == '')
		) {
			this.customfields = [];
		}

		//Classificação nova já com a última etapa preenchida
		if (
			this.isRequestBeingReclassified &&
			((!this.reverseClassification && this.requestData.id_solution_area != '') ||
				(this.reverseClassification && this.requestData.id_topic != ''))
		) {
			this.isLoadingAnalysts = true;
			this.RequestPageService.getAnalystListBySolutionArea(this.requestData.id_solution_area).subscribe((analysts) => {
				if (this.requestData.id_solution_area != this.requestDataMemory.id_solution_area) {
					// reset botão
					this.canSetDriver = false;
					this.availableAnalysts = analysts;
					for (const analyst of this.availableAnalysts) {
						if (analyst.id == this.ProfileService.userData().idAnalyst) {
							this.canSetDriver = true;
							this.changeAnalystToDriver = false;
						}
					}
					this.isLoadingAnalysts = false;
					this.openAnalystsInfoOnGroupChange();
				}
			});

			this.getCustomfieldSearch();
			this.isClassificationFulfilled = true;
		}
	}

	redirectToContact(contact: any): void {
		switch (contact.contact_type) {
			case 'WPP': {
				window.open('https://wa.me/' + contact.contact_value);
				break;
			}
			case 'TEAMS': {
				window.open('https://teams.microsoft.com/l/chat/0/0?users=' + contact.contact_value);
			}
		}
	}

	notifyAboutClassification(): void {
		this.NotificationService.setNotificationMessage(this.labels.lbl_salve_o_chamado_classificar);
	}

	isLimitDateOver(): boolean {
		return new Date() > new Date(this.requestData.limit_date);
	}

	private getTaskCustomFieldsForTask(taskId: string | number): TaskCustomField[] {
		if (!this.taskCustomFields || this.taskCustomFields.length === 0) {
			return [];
		}

		return this.taskCustomFields.filter((field: TaskCustomField) => field.idRequestTask === Number(taskId));
	}

	private isTaskCustomFieldRequired(field: TaskCustomField): boolean {
		return field.requiredTaskCustomField === 1 || field.requiredTaskCustomField === Number('1');
	}

	private isTaskCustomFieldDisabled(field: TaskCustomField): boolean {
		return field.hiddenTaskCustomField === 1 || field.disabledTaskCustomField === 1;
	}

	private isTaskCustomFieldEmpty(field: TaskCustomField): boolean {
		const value = field.requestValueTaskCustomField;

		if (value === undefined || value === null) {
			return true;
		}

		if (typeof value === 'string') {
			return value.trim() === '';
		}

		return false;
	}

	private validateTaskCustomFields(taskId: string | number): boolean {
		const fieldsForTask = this.getTaskCustomFieldsForTask(taskId);
		let hasInvalidRequiredField = false;

		for (const field of fieldsForTask) {
			const hasAlert =
				this.isTaskCustomFieldRequired(field) && !this.isTaskCustomFieldDisabled(field) && this.isTaskCustomFieldEmpty(field);
			field.alertTaskCustomField = hasAlert;

			if (hasAlert) {
				hasInvalidRequiredField = true;
			}
		}

		if (hasInvalidRequiredField) {
			this.NotificationService.setNotificationMessage(this.labels.lbl_geral_preencha_campo_obrigatorio);
			return false;
		}

		return true;
	}

	clearTaskCustomFieldAlert(field: TaskCustomField): void {
		if (!field.alertTaskCustomField) {
			return;
		}

		field.alertTaskCustomField = this.isTaskCustomFieldRequired(field) && this.isTaskCustomFieldEmpty(field);
	}

	updateTask(id_task: string, taskIndex: number, newStatus?: string): void {
		if (this.requestData.tasks[taskIndex].task_analyst == -1 || this.requestData.tasks[taskIndex].task_id_solution_area == '-1') {
			return this.NotificationService.setNotificationMessage(this.labels.lbl_geral_preencha_campo_obrigatorio);
		}

		if (this.isUpdatingTask) return;

		if (this.isRequestBeingEdited) {
			return this.NotificationService.setNotificationMessage(this.labels.lbl_geral_unsaved_changes_form);
		}

		if (newStatus) {
			this.newTask.task_status = newStatus;
		}

		this.isUpdatingTask = true;
		const taskCopy = $.extend(true, {}, this.requestData.tasks[taskIndex]);
		this.newTask.id_task = id_task;
		if (this.newTask.task_description === '') {
			this.newTask.task_description = taskCopy.task_description;
		}
		if (this.newTask.task_analyst === undefined) {
			this.newTask.task_analyst = taskCopy.task_analyst;
		}
		if (this.newTask.task_status === '') {
			this.newTask.task_status =
				taskCopy.task_available_status[0].value !== 'Pending' && taskCopy.task_available_status[0].value !== 'In Progress'
					? taskCopy.task_available_status[0].value
					: taskCopy.task_status;
		}
		if (this.newTask.attachment.length === 0) {
			this.newTask.attachment = taskCopy.attachment;
		}

		if (taskCopy.upload_required === '1' && this.newTask.attachment.length === 0) {
			this.NotificationService.setNotificationMessage(this.labels.lbl_anexar_arquivo_para_aprovar_tarefa);
			this.isUpdatingTask = false;
			return;
		}

		if (taskCopy.task_id_solution_area !== this.requestDataMemory.tasks[taskIndex].task_id_solution_area) {
			this.newTask.task_id_solution_area = taskCopy.task_id_solution_area;
		}

		const taskCustomFields = this.getTaskCustomFieldsForTask(id_task);
		if (!this.validateTaskCustomFields(id_task)) {
			this.isUpdatingTask = false;
			return;
		}

		const fieldsForTask = taskCustomFields.length > 0 ? taskCustomFields : undefined;

		const update$ = fieldsForTask
			? this.RequestPageService.updateTask(this.requestData, this.newTask, fieldsForTask)
			: this.RequestPageService.updateTask(this.requestData, this.newTask);

		update$.subscribe({
			next: () => {
				this.requestData.tasks[taskIndex].task_description = '' + this.newTask.task_description;
				this.requestData.tasks[taskIndex].task_status = '' + this.newTask.task_status;

				this.RequestPageService.getRequest(this.requestData.id).subscribe({
					next: (requestRes) => {
						this.isLoadingAvailableStatus = true;
						this.RequestPageService.getAvailableStatus(this.requestData.id).subscribe((availableStatus) => {
							this.availableStatus = availableStatus;
							this.isLoadingAvailableStatus = false;
						});

						const copyRequest = $.extend(true, {}, requestRes);
						this.requestData = copyRequest;
						this.requestDataMemory = $.extend(true, {}, this.requestData);
						this.newTask = {
							predecessor: 0,
							task_description: '',
							task_status: '',
							task_order_number: '',
							id_task: '',
							show_buttons: false,
							task_available_status: [],
							task_type: '',
							task_analyst: undefined,
							available_task_approver: [],
							selected_task_approver: [],
							available_task_analysts: [],
							already_approved_analysts: [],
							attachment: [],
							upload_required: '',
						};

						this.verifyUserTask();
					},
					error: (errorRes) => {
						console.error('getRequest:', errorRes);
					},
					complete: () => {
						this.updateFields();
						this.NotificationService.setNotificationMessage(this.labels.lbl_successful_updated);
					},
				});
			},
			error: (errorRes) => {
				this.isUpdatingTask = false;
				console.error('updateTask:', errorRes);
			},
			complete: () => {
				setTimeout(() => {
					this.isUpdatingTask = false;
				}, 2000);
			},
		});
	}

	updateTaskApprover(task_index: number): void {
		if (this.isUpdatingTask) return;

		const selectedTask = this.requestData.tasks[task_index];
		this.isUpdatingTask = true;
		selectedTask.taskApproverFormItem[0].disabled = true;
		selectedTask.taskApproverFormItem[1].disabled = true;

		selectedTask.remainingApproveList = [];
		selectedTask.remainingApproveList.push(...selectedTask.taskApproverFormItem[0].values.map((person: any) => person.label));

		const taskCustomFields = this.getTaskCustomFieldsForTask(selectedTask.id_task);
		const fieldsForTask = taskCustomFields.length > 0 ? taskCustomFields : undefined;

		const update$ = fieldsForTask
			? this.RequestPageService.updateTaskApprover(this.requestData.id, selectedTask, fieldsForTask)
			: this.RequestPageService.updateTaskApprover(this.requestData.id, selectedTask);

		update$.subscribe({
			next: () => {
				this.RequestPageService.getLog(this.requestData.id).subscribe((log) => {
					this.requestData.logs = log;
				});
				selectedTask.taskApproverFormItem[0].disabled = false;
				selectedTask.taskApproverFormItem[1].disabled = false;
			},
			error: (errorRes) => {
				selectedTask.taskApproverFormItem[0].disabled = false;
				selectedTask.taskApproverFormItem[1].disabled = false;
				this.isUpdatingTask = false;
				console.error('updateTaskApprover:', errorRes);
			},
			complete: () => {
				setTimeout(() => {
					this.verifyUserTask();
					this.NotificationService.setNotificationMessage(this.labels.lbl_successful_updated);
					this.isUpdatingTask = false;
				}, 2000);
			},
		});
	}

	setChangePlanPriority(change: changePlanInterface): void {
		change.priority =
			Number.parseInt(change.impact.toString()) +
			Number.parseInt(change.category.toString()) +
			Number.parseInt(change.risk.toString()) +
			Number.parseInt(change.urgency.toString());
	}

	updateChangePlan(): void {
		this.isUpdatingChangePlan = true;

		if (!this.requestData.changePlan[0].urgency) {
			this.requestData.changePlan[0].urgency = 1;
		}
		if (!this.requestData.changePlan[0].impact) {
			this.requestData.changePlan[0].impact = 1;
		}
		if (!this.requestData.changePlan[0].risk) {
			this.requestData.changePlan[0].risk = 1;
		}
		if (!this.requestData.changePlan[0].category) {
			this.requestData.changePlan[0].category = 1;
		}

		this.RequestPageService.updateChangePlan(this.requestData.id, this.requestData.changePlan[0]).subscribe(() => {
			this.NotificationService.setNotificationMessage(this.labels.lbl_successful_updated);
			this.isUpdatingChangePlan = false;
		});
	}

	getRelatedArticles(idRequest: string) {
		this.RequestPageService.getRequest(idRequest).subscribe(
			(requestRes) => {
				this.requestData = requestRes;
				this.newLog.status = this.requestData.status;
				this.setUserView();

				this.tabs = [
					{ tabName: this.labels.lbl_chamado_acompanhamento, changeTab: 'Acompanhamento' },
					{ tabName: this.labels.lbl_chamado_tarefas, changeTab: 'Tasks' },
				];
				if (this.userView === this.userViewTypes.ANALYST) {
					this.tabs.push(
						{ tabName: this.labels.lbl_chamado_historico_grupos, changeTab: 'Historico' },
						{ tabName: this.labels.lbl_cmdb_cis_relacionados, changeTab: 'CI' },
						{ tabName: this.labels.lbl_geral_plano_mudanca, changeTab: 'Change' },
						{ tabName: 'Related Articles', changeTab: 'relatedArticles' }
					);
				}
				if (this.tabs && this.tabs.length > 2) {
					this.tabs.splice(2, 0, { tabName: '+', changeTab: 'Plus' });
				}

				if (
					(!this.requestData.changePlan || this.requestData.changePlan.length === 0) &&
					this.requestData.service_type === 'Change'
				) {
					const newEmptyChangePlan: changePlanInterface = {
						fileAttach: '',
						riskAssessement: '',
						fallback: '',
						urgency: 1,
						impact: 1,
						risk: 1,
						category: 1,
						priority: 4,
					};
					this.requestData.changePlan.push(newEmptyChangePlan);
				}
				this.requestDataMemory = $.extend(true, {}, this.requestData);
				this.isRequestPageLoading = false;
			},
			(errorRes) => {
				this.NotificationService.setNotificationMessage(this.labels.lbl_chamado_nao_encontrado);
			}
		);
	}

	getCustomfieldSearch(): void {
		this.isCustomfieldLoading = true;

		const temporaryDicCustomfield = {};
		for (const cf of this.customfields) {
			temporaryDicCustomfield[cf.id] = cf;
		}
		const temporaryHoldCustomfield: genericFormInterface[] = [];
		this.customfields = [];

		this.RequestCustomfieldService.getCustomfieldsByClassification(
			this.requestData.id_topic,
			this.requestData.id_category,
			this.requestData.id_solution_area
		).subscribe(
			(customfieldRes) => {
				for (const cfRes of customfieldRes) {
					if (temporaryDicCustomfield[cfRes.id]) {
						temporaryHoldCustomfield.push(temporaryDicCustomfield[cfRes.id]);
					} else temporaryHoldCustomfield.push(cfRes);
				}

				this.customfields = temporaryHoldCustomfield;
				this.isCustomfieldLoading = false;
				this.isCustomfieldReclassified = true;
			},
			() => {
				this.isCustomfieldLoading = false;
			}
		);
	}

	showKbPreview(kb: relatedArticlesInterface) {
		this.currentKb = {
			id: kb.id,
			summary: kb.summary,
			description: kb.description,
			cause: kb.cause,
			resolution: kb.resolution,
			workaround: kb.workaround,
			applies: kb.applies,
			file_attach: kb.file_attach,
		};
	}

	setUserView(): void {
		this.userView =
			this.ProfileService.userData().sessionStatus === this.userViewTypes.ENDUSER
				? 0
				: (this.requestData.topic.trim() === '' &&
							this.ProfileService.userData().availableCustomers?.toString().includes(this.requestData.id_customer)) ||
					  (this.requestData.topic.trim() !== '' &&
							this.ProfileService.userData()
								.availableSolutionAreas?.toString()
								.includes(this.requestData.id_solution_area)) ||
					  this.ProfileService.userData().idAnalyst === this.requestData.id_analyst ||
					  this.ProfileService.userData().usertype == 'analyst.manager.administrator'
					? 1
					: 0;
	}

	handleFileLog(index?: number): void {
		const logFile = (<HTMLInputElement>document.querySelector('#logFile')).files;
		if (index == undefined) {
			Array.prototype.forEach.call(logFile, (file: File) => {
				if (!this.FilesService.nameAllowed(file)) {
					return this.NotificationService.setNotificationMessage(this.labels.lbl_geral_nomes_arquivos_caracteres_especiais);
				}

				this.FilesService.MSPFileFromFile(file).then((mspFile) => {
					for (let index_ = 0; index_ < this.newLog.file_log.length; index_++) {
						const logFile = this.newLog.file_log[index_];
						if (logFile.content != mspFile.content) continue;

						this.NotificationService.setNotificationMessage(this.labels.lbl_arquivo_adicionado);
						return;
					}
					if (Math.floor(mspFile.size / 1_000_000) > this.allowedMimeTypes[0].max_file_size) {
						this.NotificationService.setNotificationMessage(
							`"${mspFile.name}" ${this.labels.lbl_limite_tamanho_excedido} ${Math.floor(this.allowedMimeTypes[0].max_file_size)}MB.`
						);
					} else if (mspFile.mimeType == '' || !this.allowedMimeTypeStr.includes(mspFile.mimeType)) {
						this.NotificationService.setNotificationMessage(
							`"${mspFile.name}" ${this.labels.lbl_formato_invalido_ou_corrompido}`
						);
					} else {
						this.newLog.file_log.push(mspFile);
					}
				});
			});
		} else {
			this.newLog.file_log.splice(index, 1);
		}
	}

	handleFileTask(taskIndex: number, fileElement?: HTMLInputElement, fileIndex?: number): void {
		if (fileIndex == undefined) {
			const taskFile = fileElement.files;
			Array.prototype.forEach.call(taskFile, (file: File) => {
				if (!this.FilesService.nameAllowed(file)) {
					return this.NotificationService.setNotificationMessage(this.labels.lbl_geral_nomes_arquivos_caracteres_especiais);
				}

				this.FilesService.MSPFileFromFile(file).then((mspFile) => {
					if (Math.floor(mspFile.size / 1_000_000) > this.allowedMimeTypes[0].max_file_size) {
						this.NotificationService.setNotificationMessage(
							`"${mspFile.name}" ${this.labels.lbl_limite_tamanho_excedido} ${Math.floor(this.allowedMimeTypes[0].max_file_size)}MB.`
						);
					} else if (mspFile.mimeType == '' || !this.allowedMimeTypeStr.includes(mspFile.mimeType)) {
						this.NotificationService.setNotificationMessage(
							`"${mspFile.name}" ${this.labels.lbl_formato_invalido_ou_corrompido}`
						);
					} else {
						this.requestData.tasks[taskIndex].attachment.push(mspFile);
					}
				});
			});
		} else {
			this.requestData.tasks[taskIndex].attachment.splice(fileIndex, 1);
		}
	}

	closeDuplicateRequest(htmlReference: HTMLElement) {
		this.duplicateRequestInfo = false;
		htmlReference.innerHTML = this.labels.lbl_duplicar_chamado;
		htmlReference.classList.remove('confirm');
		clearTimeout(this.duplicateTimeout);
	}

	setConfirmButton(htmlReference: HTMLElement): void {
		if (this.ProfileService.userData().usertype.includes('enduser.regular')) {
			if (this.ProfileService.userData().fullName !== this.requestData.enduser) {
				return this.NotificationService.setNotificationMessage(
					this.labels.lbl_apenas_usuario_solicitante_pode_duplicar_proprio_chamado
				);
			} else if (this.requestData.service_type !== 'Service Request') {
				return this.NotificationService.setNotificationMessage(this.labels.lbl_apenas_permitido_duplicar_solicitacao_servico);
			}
		}
		if (this.duplicateRequestInfo == true) {
			const actualLabel = htmlReference.innerHTML;
			htmlReference.innerHTML = this.labels.lbl_geral_confirmar;

			htmlReference.classList.add('confirm');
			this.duplicateTimeout = setTimeout(() => {
				htmlReference.innerHTML = actualLabel;
				htmlReference.classList.remove('confirm');
			}, 5000);
		} else {
			this.newRequestData = { ...this.requestData };
			this.isCustomfieldLoading = true;
			this.newCustomfields = _.cloneDeep(this.customfields);
			this.isCustomfieldLoading = false;
			this.duplicateRequestInfo = true;
		}
	}

	duplyRequest(htmlReference: HTMLElement): void {
		let isNewCustomfieldFulfilled = true;
		if (this.newCustomfields && this.newCustomfields.length > 0) {
			for (const newCustomfield of this.newCustomfields) {
				if (
					newCustomfield.hidden == false &&
					newCustomfield.required == true &&
					(!newCustomfield.values[0] || newCustomfield.values[0].toString().trim() == '' || newCustomfield.values[0] == '-1')
				) {
					isNewCustomfieldFulfilled = false;
					this.NotificationService.setNotificationMessage(this.labels.lbl_geral_preencha_campo_obrigatorio);
					continue;
				}

				// Verificar se o valor excede 255 caracteres
				if (newCustomfield.values[0] && newCustomfield.values[0].toString().length > 255) {
					isNewCustomfieldFulfilled = false;
					this.NotificationService.setNotificationMessage(this.labels.lbl_geral_max_caracteres_campo_customizado);
					continue;
				}
			}
		}
		if (isNewCustomfieldFulfilled == true) {
			htmlReference.classList.add('wait');
			this.RequestPageService.duplyRequest(this.newRequestData).subscribe(
				(res: any) => {
					if (this.newCustomfields?.length > 0) {
						this.RequestPageService.postCustomfields(this.newCustomfields, res.id).subscribe();
					}
					this.NotificationService.setNotificationMessage(`${this.labels.lbl_chamado_clonado_id}'${res.id}'`);
					this.NotificationService.setFunctionOnMessage(() => {
						window.open('/request/' + res.id);
					});
					htmlReference.classList.remove('wait');
					this.duplicateRequestInfo = false;
				},
				(error) => {
					this.NotificationService.setNotificationMessage(this.labels.lbl_sem_permissao_duplicar_essa_classificacao);
					htmlReference.classList.remove('wait');
					this.duplicateRequestInfo = false;
				}
			);
		}
	}

	redirectTo(to: string): void {
		this.Router.navigate([to]);
	}

	windowTo(to: string): void {
		window.open(to);
	}

	downloadFile(filePath: string): void {
		filePath = this.formatAttachPath(filePath);
		this.RequestPageService.getFile(filePath).subscribe(
			(mspFile) => {
				this.FilesService.downloadFile(this.FilesService.fileFromBase(mspFile, 'Base64'));
			},
			(error) => {
				this.NotificationService.setNotificationMessage(this.labels.lbl_rep_custom_arquivo_nao_encontrado);
			}
		);
	}

	confirmButton(elementReference: HTMLElement): void {
		this.NotificationService.setNotificationMessage(this.labels.lbl_clique_confirmar_acao);
		elementReference.classList.add('confirmClick');
		setTimeout(() => {
			elementReference.classList.remove('confirmClick');
		}, 5000);
	}

	handleGhostResizeBar(e: MouseEvent): void {
		if (!this.ghostResizeBar.mouseDown) return;
		this.ghostResizeBar.tabContentWidth = 100 - (e.pageX / (window.innerWidth + 64)) * 100;
		this.ghostResizeBar.contentContainer = (e.pageX / (window.innerWidth + 64)) * 100;
	}

	countDownSla(): void {
		if (
			!this.requestData ||
			!this.requestData.sla_remaining ||
			<number>this.requestData.sla_remaining < 0 ||
			(this.requestData && (this.requestData.status == 'Waiting User' || this.requestData.status == 'New'))
		) {
			clearInterval(this.countDownSlaInterval);
			return;
		}

		this.requestData.sla_remaining = (<number>this.requestData.sla_remaining - 1).toString();
	}

	setTemplate(idTemplate?: string): void {
		this.resetRequest();

		if (idTemplate) this.requestTemplateId = idTemplate;

		this.isLoadingRequestTemplate = true;
		this.RequestOpeningService.getTemplate(this.requestTemplateId).subscribe((requestTemplateRes) => {
			this.requestTemplate = requestTemplateRes;
			this.requestData.description = requestTemplateRes.description;
			this.requestData.summary = requestTemplateRes.summary;

			const temporaryClassificationIds: any = {};
			temporaryClassificationIds.idSolutionArea = requestTemplateRes.id_solution_area.toString();
			temporaryClassificationIds.idServiceType = requestTemplateRes.id_service_type.toString();
			temporaryClassificationIds.idScope = requestTemplateRes.id_scope.toString();
			temporaryClassificationIds.idCategory = requestTemplateRes.id_category.toString();
			temporaryClassificationIds.idTopic = requestTemplateRes.id_topic.toString();
			temporaryClassificationIds.idImpact = null;
			temporaryClassificationIds.idUrgency = null;
			temporaryClassificationIds.idSeverity = null;
			this.classificationIds = temporaryClassificationIds;
			// this.classificationIds.idImpact = requestTemplateRes.id_solution_area.toString();
			// this.classificationIds.idUrgency = requestTemplateRes.id_solution_area.toString();
			// this.classificationIds.idSeverity = requestTemplateRes.id_solution_area.toString();

			const classificationJSON = {
				serviceType: [
					{
						id: requestTemplateRes.id_service_type,
						label: requestTemplateRes.service_type,
						name: requestTemplateRes.service_type,
					},
				],
				scope: [{ id: requestTemplateRes.id_scope, label: requestTemplateRes.scope, name: requestTemplateRes.scope }],
				category: [{ id: requestTemplateRes.id_category, label: requestTemplateRes.category, name: requestTemplateRes.category }],
				topic: [{ id: requestTemplateRes.id_topic, label: requestTemplateRes.topic, name: requestTemplateRes.topic }],
				solutionArea: [
					{
						id: requestTemplateRes.id_solution_area,
						label: requestTemplateRes.solution_area,
						name: requestTemplateRes.solution_area,
					},
				],
				severity: [],
			};
			this.setClassification(JSON.stringify(classificationJSON));
			this.isLoadingRequestTemplate = false;
		});
	}

	addTip(): void {
		for (const item of this.customfields) {
			if (item.required == 2) {
				//Chamados com customfields.required == 2 tem preenchimento obrigatório no encerramento do chamado somente.
				item.tip = this.labels.lbl_geral_preenchimento_obrigatorio;
			}
		}
	}

	/*START STYLES NOT CSS HANDLED */
	collapseContent(domElement: HTMLElement): void {
		domElement.classList.toggle('active');
		const content = <HTMLElement>domElement.nextElementSibling;
		const expectedHeight = content.scrollHeight;
		const frameRate = 1;

		if (!domElement.classList.contains('active')) {
			let index = expectedHeight;
			const expandInterval = setInterval(() => {
				if (index > 0) {
					index--;
					content.style.minHeight = index + 'px';
				} else {
					clearInterval(expandInterval);
				}
			}, frameRate);
		} else if (content.style.minHeight != expectedHeight + 'px') {
			let index = 0;
			const expandInterval = setInterval(() => {
				if (index < expectedHeight) {
					index++;
					content.style.minHeight = index + 'px';
				} else {
					clearInterval(expandInterval);
				}
			}, frameRate);
		}
	}

	fixCollapseHeight(domElement: HTMLElement): void {
		const content = <HTMLElement>domElement.nextElementSibling;
		const expectedHeight = content.scrollHeight;
		const frameRate = 1;
		if (content.offsetHeight < expectedHeight) {
			let index = content.offsetHeight;
			const expandInterval = setInterval(() => {
				if (index < expectedHeight) {
					index++;
					content.style.minHeight = index + 'px';
				} else {
					clearInterval(expandInterval);
				}
			}, frameRate);
		}
	}
	/*END STYLES NOT CSS HANDLED */

	shouldHideField(fieldName: string): boolean {
		return this.selectedFilterEnduser.includes(fieldName) || this.selectedFilterAnalyst.includes(fieldName);
	}

	countRequestDuration(value: any): void {
		this.newLog.duration == '' ? (this.newLog.duration = '00:01') : (this.newLog.duration = value);

		const [inputHoras, inputMinutos] = this.newLog.duration.split(':').map(Number);
		this.minutes = inputMinutos;
		this.hours = inputHoras;

		if (this.startTimer) {
			this.stopRequestDuration();
		} else {
			clearInterval(this.cron);
			this.startTimer = true;

			this.cronIcon = setInterval(() => {
				switch (this.currentTimerIcon) {
					case this.icons.faHourglass: {
						this.currentTimerIcon = this.icons.faHourglass1;

						break;
					}
					case this.icons.faHourglass1: {
						this.currentTimerIcon = this.icons.faHourglass2;

						break;
					}
					case this.icons.faHourglass2: {
						this.currentTimerIcon = this.icons.faHourglassEnd;

						break;
					}
					default: {
						this.currentTimerIcon = this.icons.faHourglass;
					}
				}
			}, 1500);

			this.cron = setInterval(() => {
				this.minutes++;

				if (this.minutes == 60) {
					this.hours++;
					this.minutes = 0;
				}

				if (this.minutes < 10 && this.hours < 10) {
					this.showTime = `0${this.hours}:0${this.minutes}`;
				} else if (this.minutes < 10) {
					this.showTime = `${this.hours}:0${this.minutes}`;
				} else if (this.hours < 10) {
					this.showTime = `0${this.hours}:${this.minutes}`;
				} else {
					this.showTime = `${this.hours}:${this.minutes}`;
				}

				this.newLog.duration = this.showTime;
			}, 60_000);
		}
	}

	stopRequestDuration() {
		clearInterval(this.cron);
		clearInterval(this.cronIcon);
		this.newLog.duration = this.newLog.duration;
		this.startTimer = false;
		this.currentTimerIcon = this.icons.faHourglass;
		this.formatTimer();
	}

	formatTimer() {
		if (this.newLog.duration.length === 0) {
			this.newLog.duration = '';
		} else if (this.newLog.duration.length == 1) {
			this.newLog.duration = `00:0${this.newLog.duration}`;
		} else if (this.newLog.duration.length == 2) {
			this.newLog.duration = `00:${this.newLog.duration}`;
		}

		if (this.newLog.duration.length == 5) {
			const [inputHoras, inputMinutos] = this.newLog.duration.split(':').map(Number);
			this.hours = inputHoras;
			this.minutes = inputMinutos;

			if (this.hours > 23) {
				this.hours = 23;
				this.minutes = 59;
				this.NotificationService.setNotificationMessage(this.labels.lbl_maximo_duracao);
			}

			this.minutes = this.minutes > 59 ? 59 : this.minutes;

			if (this.minutes < 10 && this.hours < 10) {
				this.showTime = `0${this.hours}:0${this.minutes}`;
			} else if (this.minutes < 10) {
				this.showTime = `${this.hours}:0${this.minutes}`;
			} else if (this.hours < 10) {
				this.showTime = `0${this.hours}:${this.minutes}`;
			} else {
				this.showTime = `${this.hours}:${this.minutes}`;
			}

			this.newLog.duration = this.showTime;
		}
	}

	getOrdinalNumber(count: string): string {
		switch (count) {
			case '1': {
				return this.labels.lbl_geral_primeiro;
			}
			case '2': {
				return this.labels.lbl_geral_segundo;
			}
			case '3': {
				return this.labels.lbl_geral_terceiro;
			}
			default: {
				return count.toString();
			}
		}
	}

	createRequestFromTask(task: string): void {
		this.RequestPageService.createRequestFromTask(this.requestData.id, task).subscribe((response: CreateRequestResponse) => {
			if (response.status === 'ok') {
				this.getAllRequestData();
			}
		});
	}

	openChildRequestPage(subrequestId: string) {
		window.open('/request/' + subrequestId, '_blank');
	}

	callSearchKbSolution() {
		this.RequestPageService.getSearchKbSolution(this.requestData.summary + ' ' + this.requestData.description).subscribe((data) => {
			this.searchResult = data;
		});
	}

	openLinkKnowSolution(itemId: string): void {
		window.open(`/knowledgebase/read/${itemId}?idRequest=${this.requestData.id}`, '_blank');
	}

	exportPDF(): void {
		// Clonagem do requestData para usar somente para geração do PDF e não usar o requestData do chamado
		const temporaryRequestData = { ...this.requestData };

		// Formatação do SLA
		temporaryRequestData.sla_remaining = this.formatSecondsToHour(temporaryRequestData.sla_remaining);

		// Sbstitua pelos nomes das colunas que deseja remover
		const columnsToRemove = [
			'available_task_analysts',
			'available_task_approver',
			'allowedCiTypes',
			'approvedList',
			'already_approved_analysts',
			'connector',
			'contacts_analyst',
			'finished',
			'id_task',
			'idLog',
			'subrequest_id',
			,
			'mandatoryCiBinding',
			'remainingApproveList',
			'show_buttons',
			'selected_task_approver',
			'taskApproverFormItem',
			'task_available_status',
		];

		const labelsTranslated: any = {
			id: 'lbl_sms_id_chamado',
			customer: 'lbl_geral_cliente',
			register_type: 'lbl_geral_tipo_registro',
			start_date: 'lbl_geral_data_inicial',
			group_approval: 'lbl_grupo_aprovadores',
			urgent_change: 'lbl_geral_change_urgente',
			response_time_limit_date: 'lbl_response_time_limit_date',
			business_hours: 'lbl_geral_horas_uteis',
			reactivated: 'lbl_geral_reativado',
			related_enduser: 'lbl_usuario_relacionado',
			risk: 'lbl_geral_risco',
			urgency: 'lbl_geral_urgencia',
			affected_location: 'lbl_localidade_afetada',
			execution_start_date: 'lbl_data_de_inicio_da_execucao',
			execution_end_date: 'lbl_data_de_termino_da_execucao',
			unavailability_start_date: 'lbl_geral_inicio_indisponibilidade',
			unavailability_end_date: 'lbl_geral_termino_indisponibilidade',
			open_date: 'lbl_chamado_data_abertura',
			sla: 'lbl_cmdb_sla',
			limit_date: 'lbl_geral_data_limite2',
			close_date: 'lbl_chamado_data_fechamento',
			summary: 'lbl_chamado_solicitacao',
			description: 'lbl_geral_descricao',
			fallback: 'lbl_geral_contorno',
			asset_type: 'lbl_geral_tipo_ativo',
			asset: 'lbl_asset_equipamento',
			service_type: 'lbl_chamado_tipo_servico',
			scope: 'lbl_geral_competencia',
			category: 'lbl_asset_category',
			topic: 'lbl_geral_topico',
			solution_area: 'lbl_geral_grupo',
			analyst: 'lbl_analista',
			severity: 'lbl_geral_severidade',
			escalation_level: 'lbl_geral_nivel_escalonamento',
			registered_by: 'lbl_geral_registrado_por',
			accepted_by: 'lbl_geral_aceito_por',
			approval_date: 'lbl_geral_data_aprovacao',
			related_request: 'lbl_chamado_relacionado',
			business_seconds: 'lbl_geral_segundo_sla',
			reoccurrence: 'lbl_recorrencia',
			sla_violation: 'lbl_geral_violacao_sla',
			fail_type: 'lbl_chamado_tipo_falha',
			enduser: 'lbl_chamado_enduser',
			status: 'lbl_geral_status',
			price: 'lbl_geral_preco',
			active: 'lbl_geral_ativo',
			change_manager: 'lbl_geral_gerente_change',
			contract_manager: 'lbl_geral_gerente_contrato',
			driver: 'lbl_general_driver',
			vip: 'lbl_VIP',
			site: 'lbl_geral_sites',
			department: 'lbl_geral_depto',
			location: 'lbl_geral_localidade',
			satisfaction_comments: 'lbl_satisfaction_comments',
			satisfaction_level: 'lbl_geral_nivel_satisfacao',
			confidential: 'lbl_geral_confidencial',
			allowedCiTypes: '',
			attached_files: 'lbl_geral_anexo',
			changePlan: 'lbl_geral_plano_mudanca',
			child_requests: 'lbl_geral_subchamado',
			classification_date: 'lbl_geral_classificacao',
			contacts_analyst: '',
			count_strikes: 'lbl_count_strikes',
			duration: 'lbl_geral_duracao',
			email_analyst: '',
			email_enduser: '',
			file_attach: 'lbl_geral_arquivo_anexado',
			history: 'lbl_chat_analyst_historico',
			idRelatedEnduser: 'lbl_usuario_relacionado',
			id_analyst: 'lbl_geral_id_analista',
			id_category: 'lbl_asset_category',
			id_customer: 'lbl_geral_cliente',
			id_enduser: 'lbl_chamado_enduser',
			id_scope: 'lbl_geral_competencia',
			id_severity: 'lbl_severidade',
			id_solution_area: 'lbl_geral_grupo',
			id_topic: 'lbl_geral_topico',
			last_strike: '',
			mandatoryCiBinding: '',
			notes: 'lbl_geral_observacoes',
			parent_request: 'lbl_chamado_pai',
			phone_enduser: 'lbl_geral_telefone',
			relatedArticles: 'lbl_geral_artigos_relacionados',
			relatedCis: 'lbl_cmdb_cis_relacionados',
			relatedEnduser: 'lbl_usuario_final_relacionado',
			risk_assessement: 'lbl_geral_risco',
			sla_remaining: 'lbl_geral_sla_nao_alcancado',
			tasks: 'lbl_chamado_tarefas',
			logs: 'lbl_chamado_acompanhamento2',
		};

		// Função para substituir os nomes dos campos pelos rótulos traduzidos
		const translateRequestData = (data: any, labelsMap: any, labelsService: any) => {
			const translatedData: any = {};

			for (const key in data) {
				if (columnsToRemove.includes(key)) continue; // Pula as colunas que devem ser removidas
				const labelKey = labelsMap[key] || key; // Obtém a chave do rótulo mapeada ou usa a original
				const translatedKey = labelsService[labelKey] || key; // Usa o rótulo traduzido do this.labels ou o nome original se não houver tradução
				translatedData[translatedKey] = data[key];
			}

			return translatedData;
		};

		// Traduza os dados da requisição usando labelsTranslated e this.labels
		const translatedRequestData = translateRequestData(temporaryRequestData, labelsTranslated, this.labels);

		// Gere o PDF com os dados traduzidos
		this.PdfGeneratorService.generatePDF(translatedRequestData, columnsToRemove);
	}

	getSolutionAreaAnalysts(solutionAreaId, index) {
		this.taskManagementService
			.getAnalystsByCustomer({ solutionAreaId: solutionAreaId, customerId: this.requestData.id_customer })
			.subscribe((analysts) => {
				this.requestData.tasks[index].available_task_analysts = analysts;
				this.requestData.tasks[index].task_analyst = -1;
			});
	}

	onSolutionAreaChange(task, index) {
		if (task.solutionArea) {
			this.taskManagementService.getAnalystsByCustomer({ solutionAreaId: task.solutionArea }).subscribe((analysts) => {
				this.newCustomTask[index].analysts = analysts;
			});
		} else {
			this.newCustomTask[index].analysts = [];
		}
	}

	addCustomTaskForm() {
		this.creatingCustomTask = true;
		this.newCustomTask.push({
			predecessor: '',
			analyst: 0,
			analysts: [],
			request: this.requestData.id,
			taskId: 0,
			solutionArea: '',
			task: '',
			type: '',
			uploadRequired: 0,
		});

		this.customTaskPredecessor = [];

		for (const task of this.requestData.tasks) {
			this.customTaskPredecessor.push(task.task_order_number);
		}

		for (const customTask of this.newCustomTask) {
			if (customTask.taskId !== Number(customTask.predecessor)) {
				this.customTaskPredecessor.push(customTask.taskId);
			}
		}
	}

	postCustomTask() {
		const customTask = [];

		for (let index = 0; index < this.newCustomTask.length; index++) {
			const task = this.newCustomTask[index];
			let fulfilledFields = true;
			let validIdTask = true;
			let validPredecessor = false;

			for (const key of Object.keys(task)) {
				if (task[key] === '' && !(key === 'uploadRequired' || key === 'analyst')) {
					fulfilledFields = false;
				}
			}

			if (!fulfilledFields) return this.NotificationService.setNotificationMessage(this.labels.lbl_preencha_todos_asteriscos);

			if (task.analyst === 0) {
				task.analyst = task.analysts.find((analyst) => analyst.is_driver === 1).id;
			}

			for (const e of this.requestData.tasks) {
				if (Number(e.task_order_number) === task.taskId || task.taskId <= 0) {
					validIdTask = false;
				}

				if (e.task_order_number === task.predecessor) {
					validPredecessor = true;
				}
			}

			if (!validIdTask)
				return this.NotificationService.setNotificationMessage(this.labels.lbl_geral_campo_id_nao_pode_ser_igual_ou_negativo);
			if (!validPredecessor)
				return this.NotificationService.setNotificationMessage(this.labels.lbl_geral_preencha_campo_predecessores);

			const predecessorRegex = new RegExp(String.raw`^\d+(;\d+)*$`);
			if (!predecessorRegex.test(task.predecessor)) {
				return this.NotificationService.setNotificationMessage(this.labels.lbl_geral_preencha_campo_predecessores);
			}

			customTask.push(
				this.RequestPageService.postCustomTask(task).pipe(
					catchError((error) => {
						return of(null); // Retorna um observable vazio em caso de erro
					})
				)
			);
		}

		forkJoin(customTask).subscribe({
			next: (results) => {
				this.getAllRequestData();
				this.NotificationService.setNotificationMessage(this.labels.lbl_adicionado_com_sucesso);
				this.clearAllCustomTask();
			},
			error: (error) => {
				this.NotificationService.setNotificationMessage(this.labels.lbl_an_errour_occour);
			},
		});
	}

	deleteCustomTask(task: any) {
		if (task.id_task) {
			this.RequestPageService.deleteCustomTask(task).subscribe(() => {
				this.getAllRequestData();
				this.NotificationService.setNotificationMessage(this.labels.lbl_geral_deletado_com_sucesso);
			});
		}
	}

	clearAllCustomTask() {
		this.newCustomTask = [];
		this.creatingCustomTask = false;
	}

	removeCreatingCustomTask(taskIndex: number) {
		this.newCustomTask.splice(taskIndex, 1);

		if (this.newCustomTask.length === 0) {
			this.clearAllCustomTask();
		}
	}

	updateCrisisTeam(): void {
		if (this.isLoadingCrisisTeam) return;

		this.isLoadingCrisisTeam = true;
		this.RequestPageService.updateCrisisTeam(this.requestData.id, this.crisisTeamForm[0].rawValues).subscribe({
			next: () => {
				this.NotificationService.setNotificationMessage(this.labels.lbl_successful_updated);
				this.RequestPageService.getLog(this.requestData.id).subscribe((logs) => {
					this.requestData.logs = logs;
				});
			},
			complete: () => {
				this.isLoadingCrisisTeam = false;
			},
		});
	}

	getTaskOptions(idRequest: string): void {
		if (
			this.requestData.service_type &&
			this.requestData.scope &&
			this.requestData.category &&
			this.requestData.topic &&
			this.requestData.solution_area
		) {
			this.taskManagementService
				.getGroupTasks({
					solutionArea: this.requestData.solution_area,
					scope: this.requestData.scope,
					category: this.requestData.category,
					topic: this.requestData.topic,
					serviceType: this.requestData.service_type,
				})
				.pipe(
					switchMap((data) => {
						this.taskOptions = data;
						this.taskIdList = this.taskOptions.map((option) => option.id);
						return this.RequestPageService.getTaskCustomFields({
							serviceType: this.requestData.service_type,
							idsSla: this.taskIdList,
							idRequest: idRequest,
						});
					})
				)
				.subscribe({
					next: (taskCustomFields) => {
						for (const field of taskCustomFields) {
							if (!field.hasOwnProperty('idRequest')) {
								field.idRequest = idRequest;
								field.solutionArea = this.requestData.solution_area;
							}
						}

						this.taskCustomFields = taskCustomFields;
						this.isTaskCustomFieldLoading = false;
					},
					error: (error) => {
						console.error('Erro ao carregar opções de tarefa:', error);
					},
				});
		}
	}

	getApproverCustomFieldNameForTask(taskId: number | string): string {
		if (!this.customfields || this.customfields.length === 0) {
			return '';
		}

		// Procura o campo customizado do chamado cujo tipo original é Select-Approver
		const approverField = this.customfields.find((cf) => cf.fieldType && cf.fieldType.toLowerCase() === 'select-approver');

		if (approverField) {
			return approverField.label || approverField.name;
		}

		return '';
	}

	updateFields(): void {
		if (!this.taskCustomFields || this.taskCustomFields.length === 0) {
			console.warn('Nenhum campo personalizado para atualizar.');
			return;
		}

		this.isLoading = true;
		this.errorMessage = null;

		this.RequestPageService.updateTaskCustomFields(this.taskCustomFields)
			.pipe(
				finalize(() => (this.isLoading = false)),
				catchError((error) => {
					console.error('Erro ao atualizar campos personalizados:', error);
					this.errorMessage = 'Falha ao atualizar os campos personalizados. Tente novamente.';
					return throwError(() => error);
				})
			)
			.subscribe((response) => {});
	}

	getRiskType(value: string): string {
		const labels: { [key: string]: string } = {
			'0': 'Normal',
			'1': 'Fast',
			'2': 'Emergencial',
		};

		return labels[value] || 'undefined'; // Retorna 'Indefinido' se não houver um valor correspondente
	}

	async loadDataAndTemplates(idCust: any) {
		try {
			this.isLoadingAvailableTemplates = true;
			const templates = await this.RequestOpeningService.getAvailableTemplates({ idCust: idCust });

			for (const template of templates) {
				const newTemplateIAC: iacOptionInterface = {
					name: template.name,
					value: template.id,
				};
				this.availableTemplateIAC.push(newTemplateIAC);
			}
		} catch (error) {
			console.error('Erro ao carregar dados ou templates:', error);
		} finally {
			this.isLoadingAvailableTemplates = false;
		}
	}

	verifyUserTask(): void {
		// Verifica se o email do usuário atual está presente em alguma tarefa.
		for (const task of this.requestData.tasks) {
			if (
				task.remainingApproveList &&
				task.remainingApproveList.length > 0 &&
				(task.task_status == 'Pending' || task.task_status == 'In Progress')
			) {
				if (task.remainingApproveList.includes(this.ProfileService.userData().fullName)) {
					this.isUserInRemainingApproveList = true;
					task.show_buttons = true;
					continue;
				} else {
					task.show_buttons = false;
				}
			} else if (
				this.ProfileService.userData().permission.includes('allow_task_permissions') ||
				(this.userView == this.userViewTypes.ANALYST &&
					task.task_type == 'Execution' &&
					this.requestData.tasks[0].available_task_analysts.some(
						(element) => this.ProfileService.userData().email == element.email
					))
			) {
				this.isUserInRemainingApproveList = true;
				task.show_buttons = true;
			}
		}
	}

	resendTaskApprovalEmail(taskIndex: number): void {
		const task = this.requestData.tasks[taskIndex];

		this.RequestPageService.resendTaskApprovalEmail(this.requestData.id, task.id_task).subscribe({
			next: (response) => {
				this.NotificationService.setNotificationMessage(this.labels.lbl_email_enviado_com_sucesso || 'Email reenviado com sucesso');
			},
			error: (error) => {
				console.error('Erro ao reenviar email:', error);
				this.NotificationService.setNotificationMessage(this.labels.lbl_an_errour_occour || 'Erro ao reenviar email');
			},
		});
	}

	canResendEmail(): boolean {
		const user = this.ProfileService.userData();
		const userType = user.usertype;
		const permissions: string = user.permission || '';

		return userType === 'analyst.manager.administrator' || permissions.includes('task_resend_email');
	}
}
